function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

function getStoreName(storeCode) {
  try {
    // Get store metafields from the script tag
    const storeMetafieldsScript = document.querySelector('#store-metafields');

    if (!storeMetafieldsScript) {
      console.warn('Store metafields not found');
      return 'Out of delivery area';
    }

    // Parse the JSON content
    const storeData = JSON.parse(storeMetafieldsScript.textContent);

    // Find the store with matching store-cd
    const store = storeData.find(s => s['store-cd'] === storeCode);

    if (store && store['store-name']) {
      return store['store-name'];
    }

    // Fallback if store not found
    console.warn(`Store with code ${storeCode} not found in metafields`);
    return 'Out of delivery area';
  } catch (error) {
    console.error('Error parsing store metafields:', error);
    return 'Out of delivery area';
  }
}

let StoreListGlobal = []
try {
  const storesDataScript = document.querySelector('script#store-metafields');
    if (storesDataScript) {
      StoreListGlobal = JSON.parse(storesDataScript.textContent)
    }
} catch {
  console.error('Parse store list data Error')
}

const storeCodeFromUrl = (() => {
  try {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get('store') || '';
  } catch (e) {
    return '';
  }
})();

function getStoreByCode(storeCode) {
  try {
    // Get store metafields from the script tag
    const storeMetafieldsScript = document.querySelector('#store-metafields');

    if (!storeMetafieldsScript) {
      console.warn('Store metafields not found');
      return 'Out of delivery area';
    }

    // Parse the JSON content
    const storeData = JSON.parse(storeMetafieldsScript.textContent);

    // Find the store with matching store-cd
    const store = storeData.find(s => s['store-cd'] === storeCode);

    if (store) {
      return store;
    }

    // Fallback if store not found
    console.warn(`Store with code ${storeCode} not found in metafields`);
    return 'Out of delivery area';
  } catch (error) {
    console.error('Error parsing store metafields:', error);
    return 'Out of delivery area';
  }
}

function formatPrice(value, precision = 2) {
  if (!value) return '';
  
  let _price = value.toString().replaceAll(',', '');
  _price = parseFloat(_price).toFixed(precision);
  const moneyFormat = '${{amount}}';

  return moneyFormat.replace('{{amount}}', _price);
}

function calcGeoDistance(lat1, lon1, lat2, lon2) {
    const toRad = angle => angle * Math.PI / 180;
    const earthRadius = 3959; // 英里，公里用 6371
    const dLat = toRad(lat2 - lat1);
    const dLon = toRad(lon2 - lon1);
    const lat1Rad = toRad(lat1);
    const lat2Rad = toRad(lat2);

    const a = Math.sin(dLat/2) ** 2 +
            Math.cos(lat1Rad) * Math.cos(lat2Rad) *
            Math.sin(dLon/2) ** 2;
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    return +(earthRadius * c).toFixed(0);
}

// {zipCode, storeList: []}
function sortStoresByZipcode(data) {
  const zipCode = data.zipCode;
  const storeList = data.storeList || [];

  if (!zipCode || storeList.length === 0) { return Promise.resolve(storeList); }

  return new Promise(async (resolve) => {
    try {
      // Use Google Maps Geocoding API to get the latitude and longitude of the zipcode
      const apiKey = window.MOR_GOOGLE_MAPS_KEY;
      const response = await fetch(`https://maps.googleapis.com/maps/api/geocode/json?address=${zipCode}&key=${apiKey}&language=en`);
      
      if (response.ok) {
        const data = await response.json();
        
        if (data.status === 'OK' && data.results.length > 0) {
          const location = data.results[0].geometry.location;
          const address_components = data.results[0].address_components;
          const userLat = location.lat;
          const userLng = location.lng;

          if (address_components) {
            let administrative_area_level_1 = ''
            let administrative_area_level_2 = ''
            address_components.map(component => {
              if (component.types.includes('administrative_area_level_1')) {
                administrative_area_level_1 = component.short_name;
              }
              if (component.types.includes('administrative_area_level_2')) {
                administrative_area_level_2 = component.short_name;
              }
            });
            if (administrative_area_level_1 && administrative_area_level_2) {
              setCookie('mor_zipcode_address', `${administrative_area_level_2}, ${administrative_area_level_1}`);
            }
          }

          // Calculate the distance from each store to the zipcode location
          storeList.forEach(store => {
            if (store.latitude && store.longitude) {
              store.distance = calcGeoDistance(userLat, userLng, store.latitude, store.longitude);
            } else {
              store.distance = null;
            }
          });

          // Sort stores by distance
          storeList.sort((a, b) => {
            if (a.distance === null) return 1;
            if (b.distance === null) return -1;
            return a.distance - b.distance;
          });
          resolve(storeList);
        } else {
          console.warn('Cannot get zipcode geolocation from Google Maps API:', data.status);
        }
        resolve(storeList);
      } else {
        console.warn('Google Maps API request failed:', response.status);
        resolve(storeList);
      }
    } catch (error) {
      console.error('Failed to get zipcode geolocation:', error);
      resolve(storeList);
    }
  }, () => {})
}

async function updateStoreLocatorPage(zipCode, storeCode) {
  const storeLocatorDrawer = document.querySelector("store-locator-drawer");
  if (storeLocatorDrawer && typeof storeLocatorDrawer.sortStoresByZipcode === "function") {
    await storeLocatorDrawer.sortStoresByZipcode(zipCode);
  }
  setTimeout(() => {
    const setMyStoreButton = document.querySelector(`set-my-store-button[data-store-code="${storeCode}"]`);
    if (setMyStoreButton) {
      setTimeout(() => setMyStoreButton.click(), 0);
    }
  }, 600)
}

function handlizeStoreName(name) {
    if (!name) return '';
    let _name = name.toLowerCase();
    if(_name === 'web warehouse') {
        _name = 'miramar showroom'
    }
    return _name.replace(/\s+/g, '-');
}

function updateStorePrices() {
  console.log('Updating store prices...');
  
  // Find all store-price elements on the page
  const storePriceElements = document.querySelectorAll('store-price');
  const storePDPPriceElements = document.querySelectorAll('store-price-pdp')
  
  if (storePriceElements.length !== 0) {
    // Trigger price update for each element
    storePriceElements.forEach(element => {
      try {
        // Re-run the store code detection and price rendering
        if (typeof element.getCurrentStoreCode === 'function') {
          element.getCurrentStoreCode();
        } else if (typeof element.getCookie === 'function') {
          const storeCode = element.getCookie('mor_store_code') || getCookie('mor_store_code') || storeCodeFromUrl || '';
          if (storeCode) {
            element.currentStoreCode = storeCode;
          }
        } else {
          const storeCode = getCookie('mor_store_code') || storeCodeFromUrl || '';
          if (storeCode) {
            element.currentStoreCode = storeCode;
          }
        }
        if (typeof element.renderPrice === 'function') {
          element.renderPrice();
        }
      } catch (e) {
        console.error('Error updating store price element:', e);
      }
    });
  }

  if (storePDPPriceElements.length !== 0) {
    storePDPPriceElements.forEach(element => {
      try {
        if (typeof element.getCurrentStoreCode === 'function' && !element.currentStoreCode) {
          element.getCurrentStoreCode();
        } else if (!element.currentStoreCode) {
          const storeCode = getCookie('mor_store_code') || storeCodeFromUrl || '';
          if (storeCode) {
            element.currentStoreCode = storeCode;
          }
        }
        if (typeof element.renderPrice === 'function') {
          element.renderPrice();
        }
      } catch (e) {
        console.error('Error updating store PDP price element:', e);
      }
    })
  }
}

function updatePdpShippingMethods(zipcode) {
  const pdpShippingMethodsDom = document.querySelector('pdp-shipping-methods [data-zipcode]');

  if (pdpShippingMethodsDom) {
    pdpShippingMethodsDom.textContent = zipcode;
  };

  const pdpShippingMethodsStoreDom = document.querySelector('pdp-shipping-methods .store-name');
  if (pdpShippingMethodsStoreDom) {
    const storesDataScript = document.querySelector('script#store-metafields');
    let storeList = []
    if (storesDataScript) {
        try {
            storeList = JSON.parse(storesDataScript.textContent);
        } catch (error) {
            console.error('Error parsing stores info JSON:', error);
        }
    }
    sortStoresByZipcode({zipCode: zipcode, storeList: storeList}).then(sortedStores => {
      const pickupAllowedStores = sortedStores.filter(store => store['store-pickup-allowed'] === 'Y');
      if (pickupAllowedStores.length > 0) {
        const closestStore = pickupAllowedStores[0];
        pdpShippingMethodsStoreDom.textContent = `${closestStore.city}, ${closestStore.st}`;
      }
    })
  }
}

function updateProductStockStatus() {
  console.log('Updating product stock status...');

  // Find all product-stock elements on the page
  const productFormElements = document.querySelectorAll('product-stock');

  if (productFormElements.length === 0) {
    console.log('No product-stock elements found on page');
    return;
  }

  // Trigger stock status update for each element
  productFormElements.forEach(element => {
    try {
      element.storeCode = getCookie('mor_store_code') || (typeof storeCodeFromUrl !== 'undefined' ? storeCodeFromUrl : '') || '';
      if (typeof element.getCurrentStoreStockStatus === 'function') {
        element.stockStatus = element.getCurrentStoreStockStatus();
      }
      if (typeof element.updateStockStatus === 'function') {
        element.updateStockStatus();
      }
    } catch (e) {
      console.error('Error updating product stock status:', e);
    }
  });
}

function updatePdpOnDisplay () {
  const pdpOnDisplayDom = document.querySelector('pdp-on-display')

  pdpOnDisplayDom && pdpOnDisplayDom.renderDom
      ? pdpOnDisplayDom.renderDom()
      : ''
}

function updateNearestShowroom() {
  const nearestShowroomDom = document.querySelector('nearest-showroom');
  if (nearestShowroomDom && typeof nearestShowroomDom.init === "function") {
    nearestShowroomDom.init();
  }
}

// {zipcode, storeCode}
async function updateCartAttribute(data) {
  if (!data || typeof data !== 'object') return

  const zipcode = data.zipcode
  const storeCode = data.storeCode

  if (!zipcode && !storeCode) {
    console.error('updateCartAttribute: Missing zipcode or storeCode');
    return
  }

  const attributes = {}
  if (zipcode) attributes['mor_zipcode'] = zipcode
  if (storeCode) attributes['mor_store_code'] = storeCode
  try {
    const response = await fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        attributes: attributes
      })
    });

    if (!response.ok) {
      throw new Error('Failed to update cart');
    }

    const cart = await response.json();
    console.log('Cart updated with:', cart.attributes);
  } catch (error) {
    console.error('Error updating cart:', error);
  }
}


async function afterStoreLocated (store) {
  const emptyText = document.querySelector('.header-zipcode-locator__result--empty');
  // Store the data in cookies
  setCookie('mor_store_name', store['store-name']);
  setCookie('mor_warehouse_code', store['region-cd']);
  setCookie('mor_store_code', store['store-cd']);

  const zipcode = getCookie('mor_zipcode')

  // Trigger price update after cookies are set
  try {
    updateStorePrices();
  } catch (error) {
    console.error('Error updating store prices:', error);
  }

  // Trigger product stock status update after cookies are set
  try {
    updateProductStockStatus();
  } catch (error) {
    console.error('Error updating product stock status:', error);
  }

  try {
    updateNearestShowroom()
  } catch (error) {
    console.error('Error updating nearest showroom:', error);
  }
  
  // update PDP shipping methods zipcode
  try {
    updatePdpShippingMethods(zipcode);
  } catch (error) {
    console.error('Error updating PDP shipping methods:', error);
  }
  const pcHeaderStoreNameDom = document.querySelector('.announcement-bar-section .utility-bar__grid header-zipcode-locator [data-store-name]');
  if (pcHeaderStoreNameDom) {
    pcHeaderStoreNameDom.textContent = store['store-name'];
  }
  const pcHeaderZipcodeDom = document.querySelector('.announcement-bar-section .utility-bar__grid header-zipcode-locator [data-zipcode]');
  if (pcHeaderZipcodeDom) {
    pcHeaderZipcodeDom.textContent = zipcode;
  }

  // Update the display with store name
  if(emptyText) emptyText.textContent = store['store-name'];

  if (document.querySelector('.header__store-locator .zip-code')) {
    document.querySelector('.header__store-locator .zip-code').textContent = zipcode;
  }

  // Update cart with store code attribute
  await updateCartAttribute(zipcode, store['store-cd']);

  // Update on display status on PDP
  updatePdpOnDisplay()

  // Update the store locator page with the new zip code and store information
  updateStoreLocatorPage(zipcode, store['store-cd']);

  const storeLocatorZipDom = document.querySelector('.store-locator__my-store-info .selected-zipcode span');
  if (storeLocatorZipDom) {
    storeLocatorZipDom.textContent = zipcode;
  }

  const productForms = document.querySelectorAll('product-form');
  productForms.forEach(form => {
    if (typeof form.updateStockStatus === 'function') {
      form.updateStockStatus();
    }
  });
}

class SectionId {
  static #separator = "__";

  // for a qualified section id (e.g. 'template--22224696705326__main'), return just the section id (e.g. 'template--22224696705326')
  static parseId(qualifiedSectionId) {
    return qualifiedSectionId.split(SectionId.#separator)[0];
  }

  // for a qualified section id (e.g. 'template--22224696705326__main'), return just the section name (e.g. 'main')
  static parseSectionName(qualifiedSectionId) {
    return qualifiedSectionId.split(SectionId.#separator)[1];
  }

  // for a section id (e.g. 'template--22224696705326') and a section name (e.g. 'recommended-products'), return a qualified section id (e.g. 'template--22224696705326__recommended-products')
  static getIdForSection(sectionId, sectionName) {
    return `${sectionId}${SectionId.#separator}${sectionName}`;
  }
}

class HTMLUpdateUtility {
  /**
   * Used to swap an HTML node with a new node.
   * The new node is inserted as a previous sibling to the old node, the old node is hidden, and then the old node is removed.
   *
   * The function currently uses a double buffer approach, but this should be replaced by a view transition once it is more widely supported https://developer.mozilla.org/en-US/docs/Web/API/View_Transitions_API
   */
  static viewTransition(
    oldNode,
    newContent,
    preProcessCallbacks = [],
    postProcessCallbacks = []
  ) {
    preProcessCallbacks?.forEach((callback) => callback(newContent));

    const newNodeWrapper = document.createElement("div");
    HTMLUpdateUtility.setInnerHTML(newNodeWrapper, newContent.outerHTML);
    const newNode = newNodeWrapper.firstChild;

    // dedupe IDs
    const uniqueKey = Date.now();
    oldNode.querySelectorAll("[id], [form]").forEach((element) => {
      element.id && (element.id = `${element.id}-${uniqueKey}`);
      element.form &&
        element.setAttribute(
          "form",
          `${element.form.getAttribute("id")}-${uniqueKey}`
        );
    });

    oldNode.parentNode.insertBefore(newNode, oldNode);
    oldNode.style.display = "none";

    postProcessCallbacks?.forEach((callback) => callback(newNode));

    setTimeout(() => oldNode.remove(), 500);
  }

  // Sets inner HTML and reinjects the script tags to allow execution. By default, scripts are disabled when using element.innerHTML.
  static setInnerHTML(element, html) {
    element.innerHTML = html;
    element.querySelectorAll("script").forEach((oldScriptTag) => {
      const newScriptTag = document.createElement("script");
      Array.from(oldScriptTag.attributes).forEach((attribute) => {
        newScriptTag.setAttribute(attribute.name, attribute.value);
      });
      newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
      oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
    });
  }
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute("role", "button");
  summary.setAttribute(
    "aria-expanded",
    summary.parentNode.hasAttribute("open")
  );

  if (summary.nextElementSibling.getAttribute("id")) {
    summary.setAttribute("aria-controls", summary.nextElementSibling.id);
  }

  summary.addEventListener("click", (event) => {
    event.currentTarget.setAttribute(
      "aria-expanded",
      !event.currentTarget.closest("details").hasAttribute("open")
    );
  });

  if (summary.closest("header-drawer, menu-drawer")) return;
  summary.parentElement.addEventListener("keyup", onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== "TAB") return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener("focusout", trapFocusHandlers.focusout);
  document.addEventListener("focusin", trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (
    elementToFocus.tagName === "INPUT" &&
    ["search", "text", "email", "url"].includes(elementToFocus.type) &&
    elementToFocus.value
  ) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    "ARROWUP",
    "ARROWDOWN",
    "ARROWLEFT",
    "ARROWRIGHT",
    "TAB",
    "ENTER",
    "SPACE",
    "ESCAPE",
    "HOME",
    "END",
    "PAGEUP",
    "PAGEDOWN",
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener("keydown", (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener("mousedown", (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    "focus",
    () => {
      if (currentFocusedElement)
        currentFocusedElement.classList.remove("focused");

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add("focused");
    },
    true
  );
}

function pauseAllMedia() {
  document.querySelectorAll(".js-youtube").forEach((video) => {
    video.contentWindow.postMessage(
      '{"event":"command","func":"' + "pauseVideo" + '","args":""}',
      "*"
    );
  });
  document.querySelectorAll(".js-vimeo").forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', "*");
  });
  document.querySelectorAll("video").forEach((video) => video.pause());
  document.querySelectorAll("product-model").forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener("focusin", trapFocusHandlers.focusin);
  document.removeEventListener("focusout", trapFocusHandlers.focusout);
  document.removeEventListener("keydown", trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== "ESCAPE") return;

  const openDetailsElement = event.target.closest("details[open]");
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector("summary");
  openDetailsElement.removeAttribute("open");
  summaryElement.setAttribute("aria-expanded", false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector("input") || this.querySelector("select");
    if (!this.input) return;
    this.changeEvent = new Event("change", { bubbles: true });
    this.input.addEventListener("change", this.onInputChange.bind(this));
    this.querySelectorAll("button").forEach((button) =>
      button.addEventListener("click", this.onButtonClick.bind(this))
    );
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(
      PUB_SUB_EVENTS.quantityUpdate,
      this.validateQtyRules.bind(this)
    );
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  onInputChange(event) {
    this.validateQtyRules();
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    if (event.target.name === "plus") {
      if (
        parseInt(this.input.dataset.min) > parseInt(this.input.step) &&
        this.input.value == 0
      ) {
        this.input.value = this.input.dataset.min;
      } else {
        this.input.stepUp();
      }
    } else {
      this.input.stepDown();
    }

    if (previousValue !== this.input.value)
      this.input.dispatchEvent(this.changeEvent);

    if (
      this.input.dataset.min === previousValue &&
      event.target.name === "minus"
    ) {
      this.input.value = parseInt(this.input.min);
    }
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      buttonMinus.classList.toggle(
        "disabled",
        parseInt(value) <= parseInt(this.input.min)
      );
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      buttonPlus.classList.toggle("disabled", value >= max);
    }
  }
}

customElements.define("quantity-input", QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function throttle(fn, delay) {
  let lastCall = 0;
  return function (...args) {
    const now = new Date().getTime();
    if (now - lastCall < delay) {
      return;
    }
    lastCall = now;
    return fn(...args);
  };
}

function fetchConfig(type = "json") {
  return {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: `application/${type}`,
    },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == "undefined") {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent("on" + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options["method"] || "post";
  var params = options["parameters"] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for (var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (
  country_domid,
  province_domid,
  options
) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(
    options["hideElement"] || province_domid
  );

  Shopify.addListener(
    this.countryEl,
    "change",
    Shopify.bind(this.countryHandler, this)
  );

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute("data-default");
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute("data-default");
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute("data-provinces");
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = "none";
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement("option");
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement("option");
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector("details");
    this.headerHideFilter = this.querySelector(".header-hide-filter");
    if (this.headerHideFilter) {
      this.headerHideFilter.addEventListener("click", this.closeMenuDrawer.bind(this));
    }
    this.addEventListener("keyup", this.onKeyUp.bind(this));
    this.addEventListener("focusout", this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll("summary").forEach((summary) =>
      summary.addEventListener("click", this.onSummaryClick.bind(this))
    );
    this.querySelectorAll(
      "button:not(.localization-selector):not(.country-selector__close-button):not(.country-filter__reset-button)"
    ).forEach((button) =>
      button.addEventListener("click", this.onCloseButtonClick.bind(this))
    );
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== "ESCAPE") return;

    const openDetailsElement = event.target.closest("details[open]");
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(
        event,
        this.mainDetailsToggle.querySelector("summary")
      )
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest(".has-submenu");
    const isOpen = detailsElement.hasAttribute("open");
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    function addTrapFocus() {
      trapFocus(
        summaryElement.nextElementSibling,
        detailsElement.querySelector("button")
      );
      summaryElement.nextElementSibling.removeEventListener(
        "transitionend",
        addTrapFocus
      );
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen
        ? this.closeMenuDrawer(event, summaryElement)
        : this.openMenuDrawer(summaryElement);

      if (window.matchMedia("(max-width: 990px)")) {
        document.documentElement.style.setProperty(
          "--viewport-height",
          `${window.innerHeight}px`
        );
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add("menu-opening");
        summaryElement.setAttribute("aria-expanded", true);
        parentMenuElement && parentMenuElement.classList.add("submenu-open");
        !reducedMotion || reducedMotion.matches
          ? addTrapFocus()
          : summaryElement.nextElementSibling.addEventListener(
            "transitionend",
            addTrapFocus
          );
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
    });
    summaryElement.setAttribute("aria-expanded", true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove("menu-opening");
    this.mainDetailsToggle.querySelectorAll("details").forEach((details) => {
      details.removeAttribute("open");
      details.classList.remove("menu-opening");
    });
    this.mainDetailsToggle
      .querySelectorAll(".submenu-open")
      .forEach((submenu) => {
        submenu.classList.remove("submenu-open");
      });
    document.body.classList.remove(
      `overflow-hidden-${this.dataset.breakpoint}`
    );
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);

    if (event instanceof KeyboardEvent)
      elementToFocus?.setAttribute("aria-expanded", false);
  }

  onFocusOut() {
    setTimeout(() => {
      if (
        this.mainDetailsToggle.hasAttribute("open") &&
        !this.mainDetailsToggle.contains(document.activeElement)
      )
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest("details");
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest(".submenu-open");
    parentMenuElement && parentMenuElement.classList.remove("submenu-open");
    detailsElement.classList.remove("menu-opening");
    detailsElement
      .querySelector("summary")
      .setAttribute("aria-expanded", false);
    removeTrapFocus(detailsElement.querySelector("summary"));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute("open");
        if (detailsElement.closest("details[open]")) {
          trapFocus(
            detailsElement.closest("details[open]"),
            detailsElement.querySelector("summary")
          );
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define("menu-drawer", MenuDrawer);

class MenuDrawer1 extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector("details");
    this.addEventListener("keyup", this.onKeyUp.bind(this));
    this.addEventListener("focusout", this.onFocusOut.bind(this));
    this.bindEvents();
  }
  bindEvents() {
    this.querySelectorAll("summary").forEach((summary) =>
      summary.addEventListener("click", this.onSummaryClick.bind(this))
    );
    this.querySelectorAll(
      "button:not(.localization-selector):not(.country-selector__close-button):not(.country-filter__reset-button)"
    ).forEach((button) =>
      button.addEventListener("click", this.onCloseButtonClick.bind(this))
    );
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== "ESCAPE") return;

    const openDetailsElement = event.target.closest("details[open]");
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(
        event,
        this.mainDetailsToggle.querySelector("summary")
      )
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest(".has-submenu");
    const isOpen = detailsElement.hasAttribute("open");
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    function addTrapFocus() {
      trapFocus(
        summaryElement.nextElementSibling,
        detailsElement.querySelector("button")
      );
      summaryElement.nextElementSibling.removeEventListener(
        "transitionend",
        addTrapFocus
      );
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen
        ? this.closeMenuDrawer(event, summaryElement)
        : this.openMenuDrawer(summaryElement);

      if (window.matchMedia("(max-width: 990px)")) {
        document.documentElement.style.setProperty(
          "--viewport-height",
          `${window.innerHeight}px`
        );
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add("menu-opening");
        summaryElement.setAttribute("aria-expanded", true);
        parentMenuElement && parentMenuElement.classList.add("submenu-open");
        !reducedMotion || reducedMotion.matches
          ? addTrapFocus()
          : summaryElement.nextElementSibling.addEventListener(
            "transitionend",
            addTrapFocus
          );
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
    });
    summaryElement.setAttribute("aria-expanded", true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove("menu-opening");
    this.mainDetailsToggle.querySelectorAll("details").forEach((details) => {
      details.removeAttribute("open");
      details.classList.remove("menu-opening");
    });
    this.mainDetailsToggle
      .querySelectorAll(".submenu-open")
      .forEach((submenu) => {
        submenu.classList.remove("submenu-open");
      });
    document.body.classList.remove(
      `overflow-hidden-${this.dataset.breakpoint}`
    );
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);

    if (event instanceof KeyboardEvent)
      elementToFocus?.setAttribute("aria-expanded", false);
  }

  onFocusOut() {
    setTimeout(() => {
      if (
        this.mainDetailsToggle.hasAttribute("open") &&
        !this.mainDetailsToggle.contains(document.activeElement)
      )
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest("details");
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest(".submenu-open");
    parentMenuElement && parentMenuElement.classList.remove("submenu-open");
    detailsElement.classList.remove("menu-opening");
    detailsElement
      .querySelector("summary")
      .setAttribute("aria-expanded", false);
    removeTrapFocus(detailsElement.querySelector("summary"));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute("open");
        if (detailsElement.closest("details[open]")) {
          trapFocus(
            detailsElement.closest("details[open]"),
            detailsElement.querySelector("summary")
          );
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define("menu-drawer1", MenuDrawer1);
class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.querySelector(".section-header");
    this.borderOffset =
      this.borderOffset ||
        this.closest(".header-wrapper").classList.contains(
          "header-wrapper--border-bottom"
        )
        ? 1
        : 0;
    document.documentElement.style.setProperty(
      "--header-bottom-position",
      `${parseInt(
        this.header.getBoundingClientRect().bottom - this.borderOffset
      )}px`
    );
    this.header.classList.add("menu-open");
    document.body.classList.add('body-mobile-menu-open')

    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
    });

    summaryElement.setAttribute("aria-expanded", true);
    window.addEventListener("resize", this.onResize);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    if (!elementToFocus) return;
    super.closeMenuDrawer(event, elementToFocus);
    document.body.classList.add('body-mobile-menu-open')
    this.header.classList.remove("menu-open");
    window.removeEventListener("resize", this.onResize);
  }

  onResize = () => {
    this.header &&
      document.documentElement.style.setProperty(
        "--header-bottom-position",
        `${parseInt(
          this.header.getBoundingClientRect().bottom - this.borderOffset
        )}px`
      );
    document.documentElement.style.setProperty(
      "--viewport-height",
      `${window.innerHeight}px`
    );
  };
}

customElements.define("header-drawer", HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      "click",
      this.hide.bind(this, false)
    );
    this.addEventListener("keyup", (event) => {
      if (event.code.toUpperCase() === "ESCAPE") this.hide();
    });
    if (this.classList.contains("media-modal")) {
      this.addEventListener("pointerup", (event) => {
        if (
          event.pointerType === "mouse" &&
          !event.target.closest("deferred-media, product-model")
        )
          this.hide();
      });
    } else {
      this.addEventListener("click", (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    this.dataset.section = this.closest(".shopify-section").id.replace(
      "shopify-section-",
      ""
    );
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector(".template-popup");
    document.body.classList.add("overflow-hidden");
    this.setAttribute("open", "");
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove("overflow-hidden");
    document.body.dispatchEvent(new CustomEvent("modalClosed"));
    this.removeAttribute("open");
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define("modal-dialog", ModalDialog);

class BulkModal extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);
      if (this.innerHTML.trim() === "") {
        const productUrl = this.dataset.url.split("?")[0];
        fetch(`${productUrl}?section_id=bulk-quick-order-list`)
          .then((response) => response.text())
          .then((responseText) => {
            const html = new DOMParser().parseFromString(
              responseText,
              "text/html"
            );
            const sourceQty = html.querySelector(
              ".quick-order-list-container"
            ).parentNode;
            this.innerHTML = sourceQty.innerHTML;
          })
          .catch((e) => {
            console.error(e);
          });
      }
    };

    new IntersectionObserver(handleIntersection.bind(this)).observe(
      document.querySelector(
        `#QuickBulk-${this.dataset.productId}-${this.dataset.sectionId}`
      )
    );
  }
}

customElements.define("bulk-modal", BulkModal);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector("button");

    if (!button) return;
    button.addEventListener("click", () => {
      const modal = document.querySelector(this.getAttribute("data-modal"));
      if (modal) modal.show(button);
    });
  }
}
customElements.define("modal-opener", ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener("click", this.loadContent.bind(this));

    if (this.getAttribute("autoplay") === "true") {
      this.loadContent(false);
    }
  }

  loadContent(focus = true) {
    // window.pauseAllMedia();
    if (!this.getAttribute("loaded")) {
      const content = document.createElement("div");
      content.appendChild(
        this.querySelector("template").content.firstElementChild.cloneNode(true)
      );

      this.setAttribute("loaded", true);
      const deferredElement = this.appendChild(
        content.querySelector("video, model-viewer, iframe")
      );
      if (focus) deferredElement.focus();
      if (
        deferredElement.nodeName == "VIDEO" &&
        deferredElement.getAttribute("autoplay")
      ) {
        // force autoplay for safari
        deferredElement.play();
      }

      // Workaround for safari iframe bug
      const formerStyle = deferredElement.getAttribute("style");
      deferredElement.setAttribute("style", "display: block;");
      window.setTimeout(() => {
        deferredElement.setAttribute("style", formerStyle);
      }, 0);
    }
  }
}

customElements.define("deferred-media", DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector(".slider-counter--current");
    this.pageTotalElement = this.querySelector(".slider-counter--total");
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver((entries) => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener("scroll", this.update.bind(this));
    this.prevButton.addEventListener("click", this.onButtonClick.bind(this));
    this.nextButton.addEventListener("click", this.onButtonClick.bind(this));
    if (this.attributes.getNamedItem("enable-wheel-scroll") !== null) {
      this.slider.addEventListener("wheel", (event) => {
        event.preventDefault();
        this.setSlidePosition(this.slider.scrollLeft + event.deltaY);
      });
    }
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(
      (element) => element.clientWidth > 0
    );
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemsToShow.sort(
      (a, b) => a.offsetLeft - b.offsetLeft
    );
    this.sliderItemOffset =
      this.sliderItemsToShow[1].offsetLeft -
      this.sliderItemsToShow[0].offsetLeft;
    const maxScroll = this.slider.scrollWidth - this.slider.clientWidth;
    this.slidesPerPage = Math.max(
      1,
      Math.round(
        this.slider.clientWidth / this.sliderItemsToShow[0].clientWidth
      )
    );
    this.totalPages = Math.max(
      1,
      this.sliderItemsToShow.filter((item) => item.offsetLeft <= maxScroll)
        .length
    );
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    // Temporarily prevents unneeded updates resulting from variant changes
    // This should be refactored as part of https://github.com/Shopify/dawn/issues/2057
    if (!this.slider || !this.nextButton) return;

    const previousPage = this.currentPage;
    this.currentPage =
      Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(
        new CustomEvent("slideChanged", {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1],
          },
        })
      );
    }

    if (this.enableSliderLooping) return;

    if (
      this.isSlideVisible(this.sliderItemsToShow[0]) &&
      this.slider.scrollLeft === 0
    ) {
      this.prevButton.setAttribute("disabled", "disabled");
    } else {
      this.prevButton.removeAttribute("disabled");
    }

    if (
      this.isSlideVisible(
        this.sliderItemsToShow[this.sliderItemsToShow.length - 1]
      )
    ) {
      this.nextButton.setAttribute("disabled", "disabled");
    } else {
      this.nextButton.removeAttribute("disabled");
    }
  }

  isSlideVisible(element, offset = 0) {
    if (!element) {
      console.warn("Element is not defined in isSlideVisible");
      return false;
    }
    const lastVisibleSlide =
      this.slider.clientWidth + this.slider.scrollLeft - offset;
    return (
      element.offsetLeft + element.clientWidth <= lastVisibleSlide &&
      element.offsetLeft >= this.slider.scrollLeft
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition =
      event.currentTarget.name === "next"
        ? this.slider.scrollLeft + step * this.sliderItemOffset
        : this.slider.scrollLeft - step * this.sliderItemOffset;
    this.setSlidePosition(this.slideScrollPosition);
  }

  setSlidePosition(position) {
    this.slider.scrollTo({
      left: position,
    });
  }
}

customElements.define("slider-component", SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector(".slider-buttons");
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector(".slideshow__slide");
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.announcementBarSlider = this.querySelector(".announcement-bar-slider");
    // Value below should match --duration-announcement-bar CSS value
    this.announcerBarAnimationDelay = this.announcementBarSlider ? 250 : 0;

    this.sliderControlLinksArray = Array.from(
      this.sliderControlWrapper.querySelectorAll(".slider-counter__link")
    );
    this.sliderControlLinksArray.forEach((link) =>
      link.addEventListener("click", this.linkToSlide.bind(this))
    );
    this.slider.addEventListener("scroll", this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.announcementBarSlider) {
      this.announcementBarArrowButtonWasClicked = false;

      this.reducedMotion = window.matchMedia(
        "(prefers-reduced-motion: reduce)"
      );
      this.reducedMotion.addEventListener("change", () => {
        if (this.slider.getAttribute("data-autoplay") === "true")
          this.setAutoPlay();
      });

      [this.prevButton, this.nextButton].forEach((button) => {
        button.addEventListener(
          "click",
          () => {
            this.announcementBarArrowButtonWasClicked = true;
          },
          { once: true }
        );
      });
    }

    if (this.slider.getAttribute("data-autoplay") === "true")
      this.setAutoPlay();
  }

  setAutoPlay() {
    this.autoplaySpeed = this.slider.dataset.speed * 1000;
    this.addEventListener("mouseover", this.focusInHandling.bind(this));
    this.addEventListener("mouseleave", this.focusOutHandling.bind(this));
    this.addEventListener("focusin", this.focusInHandling.bind(this));
    this.addEventListener("focusout", this.focusOutHandling.bind(this));

    if (this.querySelector(".slideshow__autoplay")) {
      this.sliderAutoplayButton = this.querySelector(".slideshow__autoplay");
      this.sliderAutoplayButton.addEventListener(
        "click",
        this.autoPlayToggle.bind(this)
      );
      this.autoplayButtonIsSetToPlay = true;
      this.play();
    } else {
      this.reducedMotion.matches || this.announcementBarArrowButtonWasClicked
        ? this.pause()
        : this.play();
    }
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    this.wasClicked = true;

    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) {
      this.applyAnimationToAnnouncementBar(event.currentTarget.name);
      return;
    }

    if (isFirstSlide && event.currentTarget.name === "previous") {
      this.slideScrollPosition =
        this.slider.scrollLeft +
        this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === "next") {
      this.slideScrollPosition = 0;
    }

    this.setSlidePosition(this.slideScrollPosition);

    this.applyAnimationToAnnouncementBar(event.currentTarget.name);
  }

  setSlidePosition(position) {
    if (this.setPositionTimeout) clearTimeout(this.setPositionTimeout);
    this.setPositionTimeout = setTimeout(() => {
      this.slider.scrollTo({
        left: position,
      });
    }, this.announcerBarAnimationDelay);
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll(".slider-counter__link");
    this.prevButton.removeAttribute("disabled");

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach((link) => {
      link.classList.remove("slider-counter__link--active");
      link.removeAttribute("aria-current");
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add(
      "slider-counter__link--active"
    );
    this.sliderControlButtons[this.currentPage - 1].setAttribute(
      "aria-current",
      true
    );
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton ||
        this.sliderAutoplayButton.contains(event.target);
      if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
      this.play();
    } else if (
      !this.reducedMotion.matches &&
      !this.announcementBarArrowButtonWasClicked
    ) {
      this.play();
    }
  }

  focusInHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton ||
        this.sliderAutoplayButton.contains(event.target);
      if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
        this.play();
      } else if (this.autoplayButtonIsSetToPlay) {
        this.pause();
      }
    } else if (this.announcementBarSlider.contains(event.target)) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute("aria-live", "off");
    clearInterval(this.autoplay);
    this.autoplay = setInterval(
      this.autoRotateSlides.bind(this),
      this.autoplaySpeed
    );
  }

  pause() {
    this.slider.setAttribute("aria-live", "polite");
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add("slideshow__autoplay--paused");
      this.sliderAutoplayButton.setAttribute(
        "aria-label",
        window.accessibilityStrings.playSlideshow
      );
    } else {
      this.sliderAutoplayButton.classList.remove("slideshow__autoplay--paused");
      this.sliderAutoplayButton.setAttribute(
        "aria-label",
        window.accessibilityStrings.pauseSlideshow
      );
    }
  }

  autoRotateSlides() {
    const slideScrollPosition =
      this.currentPage === this.sliderItems.length
        ? 0
        : this.slider.scrollLeft + this.sliderItemOffset;

    this.setSlidePosition(slideScrollPosition);
    this.applyAnimationToAnnouncementBar();
  }

  setSlideVisibility(event) {
    this.sliderItemsToShow.forEach((item, index) => {
      const linkElements = item.querySelectorAll("a");
      if (index === this.currentPage - 1) {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.removeAttribute("tabindex");
          });
        item.setAttribute("aria-hidden", "false");
        item.removeAttribute("tabindex");
      } else {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.setAttribute("tabindex", "-1");
          });
        item.setAttribute("aria-hidden", "true");
        item.setAttribute("tabindex", "-1");
      }
    });
    this.wasClicked = false;
  }

  applyAnimationToAnnouncementBar(button = "next") {
    if (!this.announcementBarSlider) return;

    const itemsCount = this.sliderItems.length;
    const increment = button === "next" ? 1 : -1;

    if (isNaN(this.currentPage)) return;
    const currentIndex = this.currentPage - 1;
    let nextIndex = (currentIndex + increment) % itemsCount;
    nextIndex = nextIndex === -1 ? itemsCount - 1 : nextIndex;

    const nextSlide = this.sliderItems[nextIndex];
    const currentSlide = this.sliderItems[currentIndex];

    const animationClassIn = "announcement-bar-slider--fade-in";
    const animationClassOut = "announcement-bar-slider--fade-out";

    const isFirstSlide = currentIndex === 0;
    const isLastSlide = currentIndex === itemsCount - 1;

    const shouldMoveNext =
      (button === "next" && !isLastSlide) ||
      (button === "previous" && isFirstSlide);
    const direction = shouldMoveNext ? "next" : "previous";

    currentSlide.classList.add(`${animationClassOut}-${direction}`);
    nextSlide.classList.add(`${animationClassIn}-${direction}`);

    setTimeout(() => {
      currentSlide.classList.remove(`${animationClassOut}-${direction}`);
      nextSlide.classList.remove(`${animationClassIn}-${direction}`);
    }, this.announcerBarAnimationDelay * 2);
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition =
      this.slider.scrollLeft +
      this.sliderFirstItemNode.clientWidth *
      (this.sliderControlLinksArray.indexOf(event.currentTarget) +
        1 -
        this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }
}

customElements.define("slideshow-component", SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.addEventListener("change", (event) => {
      const target = this.getInputForEventTarget(event.target);
      this.updateSelectionMetadata(event);

      publish(PUB_SUB_EVENTS.optionValueSelectionChange, {
        data: {
          event,
          target,
          selectedOptionValues: this.selectedOptionValues,
          selectedOptionsNameValues: this.selectedOptionsNameValues,
        },
      });
    });
  }

  updateSelectionMetadata({ target }) {
    const { value, tagName } = target;

    if (tagName === "SELECT" && target.selectedOptions.length) {
      Array.from(target.options)
        .find((option) => option.getAttribute("selected"))
        .removeAttribute("selected");
      target.selectedOptions[0].setAttribute("selected", "selected");

      const swatchValue = target.selectedOptions[0].dataset.optionSwatchValue;
      const selectedDropdownSwatchValue = target
        .closest(".product-form__input")
        .querySelector("[data-selected-value] > .swatch");
      if (!selectedDropdownSwatchValue) return;
      if (swatchValue) {
        selectedDropdownSwatchValue.style.setProperty(
          "--swatch--background",
          swatchValue
        );
        selectedDropdownSwatchValue.classList.remove("swatch--unavailable");
      } else {
        selectedDropdownSwatchValue.style.setProperty(
          "--swatch--background",
          "unset"
        );
        selectedDropdownSwatchValue.classList.add("swatch--unavailable");
      }

      selectedDropdownSwatchValue.style.setProperty(
        "--swatch-focal-point",
        target.selectedOptions[0].dataset.optionSwatchFocalPoint || "unset"
      );
    } else if (tagName === "INPUT" && target.type === "radio") {
      const selectedSwatchValue = target
        .closest(`.product-form__input`)
        .querySelector("[data-selected-value]");
      if (selectedSwatchValue) selectedSwatchValue.innerHTML = value;
    }
  }

  getInputForEventTarget(target) {
    return target.tagName === "SELECT" ? target.selectedOptions[0] : target;
  }

  get selectedOptionValues() {
    return Array.from(
      this.querySelectorAll("select option[selected], fieldset input:checked")
    ).map(({ dataset }) => dataset.optionValueId);
  }

  get selectedOptionsNameValues() {
    return Array.from(
      this.querySelectorAll("select option[selected], fieldset input:checked")
    ).map((input) => input.value);
  }
}

customElements.define("variant-selects", VariantSelects);

class ProductRecommendations extends HTMLElement {
  observer = undefined;

  constructor() {
    super();
  }

  connectedCallback() {
    this.initializeRecommendations(this.dataset.productId);
  }

  initializeRecommendations(productId) {
    this.observer?.unobserve(this);
    this.observer = new IntersectionObserver(
      (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);
        this.loadRecommendations(productId);
      },
      { rootMargin: "0px 0px 400px 0px" }
    );
    this.observer.observe(this);
  }

  loadRecommendations(productId) {
    fetch(
      `${this.dataset.url}&product_id=${productId}&section_id=${this.dataset.sectionId}`
    )
      .then((response) => response.text())
      .then((text) => {
        const html = document.createElement("div");
        html.innerHTML = text;
        const recommendations = html.querySelector("product-recommendations");

        if (recommendations?.innerHTML.trim().length) {
          this.innerHTML = recommendations.innerHTML;
        }

        if (
          !this.querySelector("slideshow-component") &&
          this.classList.contains("complementary-products")
        ) {
          this.remove();
        }

        if (html.querySelector(".grid__item")) {
          this.classList.add("product-recommendations--loaded");
        }
      })
      .catch((e) => {
        console.error(e);
      });
  }
}

customElements.define("product-recommendations", ProductRecommendations);

class AccountIcon extends HTMLElement {
  constructor() {
    super();

    this.icon = this.querySelector(".icon");
  }

  connectedCallback() {
    document.addEventListener(
      "storefront:signincompleted",
      this.handleStorefrontSignInCompleted.bind(this)
    );
  }

  handleStorefrontSignInCompleted(event) {
    if (event?.detail?.avatar) {
      this.icon?.replaceWith(event.detail.avatar.cloneNode());
    }
  }
}

customElements.define("account-icon", AccountIcon);

class BulkAdd extends HTMLElement {
  static ASYNC_REQUEST_DELAY = 250;

  constructor() {
    super();
    this.queue = [];
    this.setRequestStarted(false);
    this.ids = [];
  }

  startQueue(id, quantity) {
    this.queue.push({ id, quantity });

    const interval = setInterval(() => {
      if (this.queue.length > 0) {
        if (!this.requestStarted) {
          this.sendRequest(this.queue);
        }
      } else {
        clearInterval(interval);
      }
    }, BulkAdd.ASYNC_REQUEST_DELAY);
  }

  sendRequest(queue) {
    this.setRequestStarted(true);
    const items = {};

    queue.forEach((queueItem) => {
      items[parseInt(queueItem.id)] = queueItem.quantity;
    });
    this.queue = this.queue.filter(
      (queueElement) => !queue.includes(queueElement)
    );

    this.updateMultipleQty(items);
  }

  setRequestStarted(requestStarted) {
    this._requestStarted = requestStarted;
  }

  get requestStarted() {
    return this._requestStarted;
  }

  resetQuantityInput(id) {
    const input = this.querySelector(`#Quantity-${id}`);
    input.value = input.getAttribute("value");
    this.isEnterPressed = false;
  }

  setValidity(event, index, message) {
    event.target.setCustomValidity(message);
    event.target.reportValidity();
    this.resetQuantityInput(index);
    event.target.select();
  }

  validateQuantity(event) {
    const inputValue = parseInt(event.target.value);
    const index = event.target.dataset.index;

    if (inputValue < event.target.dataset.min) {
      this.setValidity(
        event,
        index,
        window.quickOrderListStrings.min_error.replace(
          "[min]",
          event.target.dataset.min
        )
      );
    } else if (inputValue > parseInt(event.target.max)) {
      this.setValidity(
        event,
        index,
        window.quickOrderListStrings.max_error.replace(
          "[max]",
          event.target.max
        )
      );
    } else if (inputValue % parseInt(event.target.step) != 0) {
      this.setValidity(
        event,
        index,
        window.quickOrderListStrings.step_error.replace(
          "[step]",
          event.target.step
        )
      );
    } else {
      event.target.setCustomValidity("");
      event.target.reportValidity();
      event.target.setAttribute("value", inputValue);
      this.startQueue(index, inputValue);
    }
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector).innerHTML;
  }
}

if (!customElements.get("bulk-add")) {
  customElements.define("bulk-add", BulkAdd);
}

class CartPerformance {
  static #metric_prefix = "cart-performance";

  static createStartingMarker(benchmarkName) {
    const metricName = `${CartPerformance.#metric_prefix}:${benchmarkName}`;
    return performance.mark(`${metricName}:start`);
  }

  static measureFromEvent(benchmarkName, event) {
    const metricName = `${CartPerformance.#metric_prefix}:${benchmarkName}`;
    const startMarker = performance.mark(`${metricName}:start`, {
      startTime: event.timeStamp,
    });

    const endMarker = performance.mark(`${metricName}:end`);

    performance.measure(
      benchmarkName,
      `${metricName}:start`,
      `${metricName}:end`
    );
  }

  static measureFromMarker(benchmarkName, startMarker) {
    const metricName = `${CartPerformance.#metric_prefix}:${benchmarkName}`;
    const endMarker = performance.mark(`${metricName}:end`);

    performance.measure(benchmarkName, startMarker.name, `${metricName}:end`);
  }

  static measure(benchmarkName, callback) {
    const metricName = `${CartPerformance.#metric_prefix}:${benchmarkName}`;
    const startMarker = performance.mark(`${metricName}:start`);

    callback();

    const endMarker = performance.mark(`${metricName}:end`);

    performance.measure(
      benchmarkName,
      `${metricName}:start`,
      `${metricName}:end`
    );
  }
}

customElements.define(
  "card-action",
  class extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.handle = this.querySelector("[data-toggle]");
      if (!this.handle) return;

      this.style.setProperty(
        "--max-height",
        this.querySelector("[data-inner]").clientHeight + "px"
      );

      this.handle.addEventListener("click", () => {
        if (this.hasAttribute("open")) {
          this.removeAttribute("open");
        } else {
          this.setAttribute("open", "");
        }
      });
    }
  }
);

/*
  Demo:
  <common-swiper>
    <script type="application/json" data-swiper-config>
      {
        "slidesPerView": 1.4,
        "spaceBetween": 16,
        "ResizeObserverSize": true,
        "breakpoints": {
          "768": {
            "slidesPerView": 2.4,
            "spaceBetween": 20
          }
        }
      }
    </script>
    <div class="swiper">
      <div class="swiper-wrapper">
        <div class="swiper-slide"></div>
        <div class="swiper-slide"></div>
      </div>
    </div>
  </common-swiper>
*/

// iOS/iPadOS doesn't render -webkit-scrollbar styling; flag it so CSS can drop the reserved scrollbar space
(function () {
  const isIOS =
    /iPad|iPhone|iPod/.test(navigator.userAgent) ||
    (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1);
  if (isIOS) {
    document.documentElement.classList.add("no-scrollbar");
  }
})();

class CommonSwiper extends HTMLElement {
  // 函数返回避免数据共享
  static config = () => ({
    slidesPerView: 1,
    spaceBetween: 10,
    breakpoints: {
      768: {
        spaceBetween: 24,
      },
      1240: {
        spaceBetween: 32,
      },
    },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
  });

  constructor() {
    super();

    this.only_mobile = this.hasAttribute("only-mobile");
    this.swiper = null;
    this.lazyObserver = null;
  }

  checkAndInitSwiper() {
    const needCancel = this.hasAttribute("mobile-free-mode") && window.innerWidth < 768;
    if (needCancel) {
      if (this.swiper) {
        this.swiper.destroy(true, true);
        this.swiper = null;
      }
    } else {
      if (!this.swiper) {
        this.initSwiper();
      }
    }
  }

  initSwiper() {
    this.config = this.getConfig();
    this.swiper = new Swiper(this.container, this.config);
    this.dispatchEvent(new CustomEvent('swiper:init', { detail: { swiper: this.swiper } }));
  }

  removeSlide(slide) {
    slide.remove();
    if (this.swiper) this.swiper.update();
    const wrapper = this.querySelector('.swiper-wrapper');
    if (!wrapper) return;
    const templates = wrapper.querySelectorAll(':scope > template');
    if (templates.length) {
      templates.forEach(function(t) {
        const s = document.createElement('div');
        s.className = 'swiper-slide';
        s.innerHTML = t.innerHTML;
        t.replaceWith(s);
      });
      if (this.swiper) this.swiper.update();
      return;
    }
    if (this._ajaxRemains?.length) {
      this._ajaxLoadBatch?.();
    } else if (this.config?.lazyloadPageUrl) {
      this.observeLastSlide(wrapper);
    }
  }

  initLazyLoad() {
    const isTemplateLazy = this.hasAttribute('custom-lazyload');
    const isAjaxLazy = this.config?.lazyloadPageUrl;
    if (!isTemplateLazy && !isAjaxLazy) return;
    const wrapper = this.querySelector('.swiper-wrapper');
    if (!wrapper) return;

    if (isAjaxLazy) {
      this.initAjaxLazyLoad(wrapper);
    } else {
      this.initTemplateLazyLoad(wrapper);
    }
  }

  initTemplateLazyLoad(wrapper) {
    const getTemplates = () => wrapper.querySelectorAll(':scope > template');
    if (!getTemplates().length) return;

    const self = this;
    const loadBatch = (count) => {
      const batch = Array.from(getTemplates()).slice(0, count);
      batch.forEach(function(t) {
        const slide = document.createElement('div');
        slide.className = 'swiper-slide';
        slide.innerHTML = t.innerHTML;
        t.replaceWith(slide);
      });
      if (self.swiper) self.swiper.update();
      self.observeLastSlide(wrapper);
    };

    const getBatchSize = () => {
      if (self.swiper) {
        return Math.ceil(self.swiper.params.slidesPerView || 1);
      }
      const first = wrapper.querySelector('.swiper-slide');
      const slideW = first ? first.offsetWidth : 300;
      return Math.ceil((self.offsetWidth || 375) / slideW) || 1;
    };

    this.lazyObserver = new IntersectionObserver(function(entries) {
      if (entries[0].isIntersecting && getTemplates().length) {
        loadBatch(getBatchSize());
      }
    }, { rootMargin: '100px' });

    this.observeLastSlide(wrapper);
  }

  addLoadingToWrapper(wrapper) {
    const spinner = document.createElement('div');
    spinner.className = 'loading__spinner';
    spinner.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" class="spinner" viewBox="0 0 66 66" width="16" height="16"><circle stroke-width="6" cx="33" cy="33" r="30" fill="none" class="path"/></svg>';
    wrapper.closest('.swiper').append(spinner);
    wrapper.closest('.swiper').classList.add('lazyload-loading-parent')
  }

  removeLoadingOfWrapper(wrapper) {
    wrapper.closest('.swiper').classList.remove('lazyload-loading-parent')
    const spinner = wrapper.closest('.swiper').querySelector('.loading__spinner');
    if (spinner) spinner.remove();
  }

  initAjaxLazyLoad(wrapper) {
    if (this._ajaxLoading) return;
    this._ajaxLoading = true;
    this._ajaxRemains = [];

    const self = this;
    this._ajaxLoadBatch = () => {
      const batchSize = self.config.lazyloadInitProductCount || 1;
      const batch = self._ajaxRemains.splice(0, batchSize);
      if (!batch.length) return;
      batch.forEach(function(slide) {
        wrapper.append(slide.cloneNode(true));
      });
      if (self.swiper) self.swiper.update();
      self._ajaxLoading = false;
      if (self._ajaxRemains.length) {
        requestAnimationFrame(function() {
          self.observeLastSlide(wrapper);
        });
      }
    };

    this.lazyObserver = new IntersectionObserver(function(entries) {
      if (!entries[0].isIntersecting) return;
      self.lazyObserver.disconnect();
      if (self._ajaxRemains.length) {
        self._ajaxLoadBatch();
      } else {
        self.addLoadingToWrapper(wrapper)
        const url = self.config.lazyloadPageUrl;
        fetch(url)
          .then(function(response) { return response.text(); })
          .then(function(html) {
            const doc = new DOMParser().parseFromString(html, 'text/html');
            const root = doc.querySelector(self.config.lazyloadWrapperSelector);
            const slides = Array.from(root.querySelectorAll('.swiper-slide'));
            self._ajaxRemains = slides.slice(self.config.lazyloadInitProductCount || 0);
            self._ajaxLoading = false;
            self._ajaxLoadBatch();
          })
          .catch(function() {
            self._ajaxLoading = false;
          })
          .finally(function() {
            self.removeLoadingOfWrapper(wrapper)
          });
      }
    }, { rootMargin: '100px' });

    this.observeLastSlide(wrapper);
  }

  observeLastSlide(wrapper) {
    if (!this.lazyObserver) return;
    const slides = wrapper.querySelectorAll('.swiper-slide');
    const last = slides[slides.length - 1];
    if (last) {
      this.lazyObserver.disconnect();
      this.lazyObserver.observe(last);
    }
  }

  getConfig() {
    let config =
      JSON.parse(
        this.querySelector("script[data-swiper-config]")?.textContent || null
      ) || null;
    config = config || CommonSwiper.config();
    if (config.navigation) {
      // 判断config.navigation.nextEl是dom对象还是字符串
      if (typeof config.navigation.nextEl === "string") {
        config.navigation.nextEl = this.querySelector(
          config.navigation.nextEl
        );
      }
      if (typeof config.navigation.prevEl === "string") {
        config.navigation.prevEl = this.querySelector(
          config.navigation.prevEl
        );
      }
    }
    if (config.scrollbar) {
      // 判断config.pagination.el是dom对象还是字符串
      if (typeof config.scrollbar.el === "string") {
        config.scrollbar.el = this.querySelector(config.scrollbar.el);
      }
    }
    if (this.querySelector(".swiper-pagination")) {
      config.pagination = {
        el: this.querySelector(".swiper-pagination"),
        clickable: true,
      };
    } else {
      delete config.pagination;
    }
    return config;
  }

  connectedCallback() {
    if (this.only_mobile && window.innerWidth >= 768) return;
    this.container = this.querySelector(".swiper");
    if (!this.container) return;
    if (!this.querySelectorAll(".swiper-slide")?.length) return;

    this.checkAndInitSwiper();
    this.initLazyLoad();
    if (this.hasAttribute("mobile-free-mode")) {
      window.addEventListener("resize", this.checkAndInitSwiper.bind(this));
    }
  }

  disconnectedCallback() {
    if (this.lazyObserver) {
      this.lazyObserver.disconnect();
      this.lazyObserver = null;
    }
    if (this.hasAttribute("mobile-free-mode")) {
      window.removeEventListener("resize", this.checkAndInitSwiper.bind(this));
    }
    if (this.swiper) {
      this.swiper.destroy(true, true);
      this.swiper = null;
    }
  }
}
customElements.define("common-swiper", CommonSwiper);

customElements.define(
  "common-swiper1",
  class CommonSwiper1 extends HTMLElement {
    constructor() {
      super();

      this.only_mobile = this.hasAttribute("only-mobile");
    }
    connectedCallback() {
      if (this.only_mobile && window.innerWidth >= 768) return;
      this.container = this.querySelector(".swiper");
      if (!this.container) return;
      if (!this.querySelectorAll(".swiper-slide")?.length) return;
      this.initSwiper();
    }
    initSwiper() {
      this.config = this.getConfig();
      this.swiper = new Swiper(this.container, this.config);
      this.querySelectorAll(".swiper-pagination .swiper-pagination-bullet").forEach((item, index) => {
        item.style.backgroundImage = `url(${this.config.medias[index].preview_image.src + '?width=90&height=90'})`;
      });
    }

    getConfig() {
      let config = window.kitchenProductInfoSwiperConfig;
      if (config.navigation) {
        // 判断config.navigation.nextEl是dom对象还是字符串
        if (typeof config.navigation.nextEl === "string") {
          config.navigation.nextEl = this.querySelector(
            config.navigation.nextEl
          );
        }
        if (typeof config.navigation.prevEl === "string") {
          config.navigation.prevEl = this.querySelector(
            config.navigation.prevEl
          );
        }
      }
      if (config.scrollbar) {
        // 判断config.pagination.el是dom对象还是字符串
        if (typeof config.scrollbar.el === "string") {
          config.scrollbar.el = this.querySelector(config.scrollbar.el);
        }
      }
      if (this.querySelector(".swiper-pagination")) {
        config.pagination = {
          el: this.querySelector(".swiper-pagination"),
          clickable: true
        };
      } else {
        delete config.pagination;
      }
      return config;
    }
  }
);
customElements.define(
  "countdown-timer",
  class extends HTMLElement {
    constructor() {
      super();

      this.attachShadow({ mode: "open" });
      this.start = new Date(this.dataset.start).getTime();
      this.end = new Date(this.dataset.end).getTime();

      this.controller = {
        days: {
          number: 0,
          cards: [],
        },
        hours: {
          number: 0,
          cards: [],
        },
        minutes: {
          number: 0,
          cards: [],
        },
        seconds: {
          number: 0,
          cards: [],
        },
      };

      if (this.dataset.start && this.start > Date.now()) {
        this.style.display = "none";
        // 设置一个定时器在开始时间到达时显示
        setTimeout(() => {
          this.style.display = "";
          this.init();
        }, this.start - Date.now());
        return;
      }

      this.init();
    }

    init() {
      // 初始化HTML结构
      this.shadowRoot.innerHTML = `
      <style>
        .countdown-wrapper {
          display: flex;
          gap: 10px;
          justify-content: center;
        }
        .countdown-item {
          display: flex;
          flex-direction: column;
          align-items: center;
          gap: 5px;
        }
        .flip-deck {
          display: flex;
          gap: 1px;
        }
        .flip-card {
          --card-width: 16px;
          --card-height: 22px;
          width: var(--card-width);
          height: var(--card-height);
          box-sizing: border-box;
          text-align: center;
          font-size: 16px;
          font-weight: bold;
          line-height: var(--card-height);
        }
        .flip-card-wrapper{
          position: relative;
          height: calc(var(--card-height) / 2);
        }
        .top{
          position: relative;
        }
        .bottom{
          line-height: 0;
        }
        .block{
          width: 100%;
          height: 100%;
          background-color: black;
          overflow: hidden;
          border-radius: 3px 3px 0 0;
        }
        .block:last-child{
          border-radius: 0 0 3px 3px;
        }
        .card-box{
          position: absolute;
          top: 0;
          width: 100%;
          height: 100%;
          transform-style: preserve-3d;
          transform-origin: bottom;
          transition: all 0.5s;
        }
        .card-box:hover{
          transform: perspective(var(--card-height)) rotateX(-180deg);
        }
        .card-block{
          position: absolute;
          width: 100%;
          height: 100%;
          backface-visibility:hidden;
          overflow: hidden;
        }
        .front {
          border-radius: 3px 3px 0 0;
          background-color: #000;
        }
        .back {
          border-radius: 0 0 3px 3px;
          background-color: #000;
          transform: rotateX(0deg) rotateY(-180deg) scale(-1);
          line-height: 0px;
        }
        .label {
          font-size: 14px;
          color: #666;
          display: none;
        }
        @media screen and (max-width: 767px) {
          .countdown-wrapper {
            gap: 5px;
          }
          .flip-card {
            --card-width: 13px;
            font-size: 12px;
          }
          .countdown-item:last-child {
            display: none;
          }
        }
      </style>
      <div class="countdown-wrapper">
        <div class="countdown-item">
          <div class="flip-deck" data-unit="days">
            <div class="flip-card">
              <div class="flip-card-wrapper">
                <div class="top block">0</div>
                <div class="card-box">
                  <div class="card-block front">0</div>
                  <div class="card-block back">0</div>
                </div>
                <div class="bottom block">0</div>
              </div>
            </div>
            <div class="flip-card">
              <div class="flip-card-wrapper">
                <div class="top block">0</div>
                <div class="card-box">
                  <div class="card-block front">0</div>
                  <div class="card-block back">0</div>
                </div>
                <div class="bottom block">0</div>
              </div>
            </div>
          </div>
          <span class="label">Days</span>
        </div>
        <div class="countdown-item">
          <div class="flip-deck" data-unit="hours">
            <div class="flip-card">
              <div class="flip-card-wrapper">
                <div class="top block">0</div>
                <div class="card-box">
                  <div class="card-block front">0</div>
                  <div class="card-block back">0</div>
                </div>
                <div class="bottom block">0</div>
              </div>
            </div>
            <div class="flip-card">
              <div class="flip-card-wrapper">
                <div class="top block">0</div>
                <div class="card-box">
                  <div class="card-block front">0</div>
                  <div class="card-block back">0</div>
                </div>
                <div class="bottom block">0</div>
              </div>
            </div>
          </div>
          <span class="label">Hours</span>
        </div>
        <div class="countdown-item">
          <div class="flip-deck" data-unit="minutes">
            <div class="flip-card">
              <div class="flip-card-wrapper">
                <div class="top block">0</div>
                <div class="card-box">
                  <div class="card-block front">0</div>
                  <div class="card-block back">0</div>
                </div>
                <div class="bottom block">0</div>
              </div>
            </div>
            <div class="flip-card">
              <div class="flip-card-wrapper">
                <div class="top block">0</div>
                <div class="card-box">
                  <div class="card-block front">0</div>
                  <div class="card-block back">0</div>
                </div>
                <div class="bottom block">0</div>
              </div>
            </div>
          </div>
          <span class="label">Mins</span>
        </div>
        <div class="countdown-item">
          <div class="flip-deck" data-unit="seconds">
            <div class="flip-card">
              <div class="flip-card-wrapper">
                <div class="top block">0</div>
                <div class="card-box">
                  <div class="card-block front">0</div>
                  <div class="card-block back">0</div>
                </div>
                <div class="bottom block">0</div>
              </div>
            </div>
            <div class="flip-card">
              <div class="flip-card-wrapper">
                <div class="top block">0</div>
                <div class="card-box">
                  <div class="card-block front">0</div>
                  <div class="card-block back">0</div>
                </div>
                <div class="bottom block">0</div>
              </div>
            </div>
          </div>
          <span class="label">Secs</span>
        </div>
      </div>
    `;

      this.flipDeck = {
        days: this.shadowRoot.querySelector('[data-unit="days"]'),
        hours: this.shadowRoot.querySelector('[data-unit="hours"]'),
        minutes: this.shadowRoot.querySelector('[data-unit="minutes"]'),
        seconds: this.shadowRoot.querySelector('[data-unit="seconds"]'),
      };
    }

    connectedCallback() {
      this.updateTimer(true);
      this.timer = setInterval(() => this.updateTimer(), 10);
      // requestAnimationFrame(this.updateTimer.bind(this));
    }

    disconnectedCallback() {
      clearInterval(this.timer);
    }

    updateTimer(init = false) {
      const now = Date.now();
      const timeLeft = Math.max(0, this.end - now);

      if (timeLeft === 0) {
        clearInterval(this.timer);
        this.dispatchEvent(new CustomEvent("countdown-end"));
        this.hide();
        return;
      }

      const days = Math.floor(timeLeft / (1000 * 60 * 60 * 24));
      const hours = Math.floor(
        (timeLeft % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
      );
      const minutes = Math.floor((timeLeft % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((timeLeft % (1000 * 60)) / 1000);

      if (init) {
        this.initDateDom(days, hours, minutes, seconds);
        return;
      }

      this.updateFlipCard("days", days);
      this.updateFlipCard("hours", hours);
      this.updateFlipCard("minutes", minutes);
      this.updateFlipCard("seconds", seconds);
    }

    hide() {
      this.style.display = "none";
    }

    initDateDom(days, hours, minutes, seconds) {
      const arr = ["days", "hours", "minutes", "seconds"];
      this.controller.days.number = String(days).padStart(2, "0").split("");
      this.controller.hours.number = String(hours).padStart(2, "0").split("");
      this.controller.minutes.number = String(minutes)
        .padStart(2, "0")
        .split("");
      this.controller.seconds.number = String(seconds)
        .padStart(2, "0")
        .split("");
      arr.forEach((key, index) => {
        const current = String(arguments[index]).padStart(2, "0");
        const next =
          arguments[index] - 1 < 0
            ? this.getNextNumber(key)
            : String(arguments[index] + 1).padStart(2, "0");
        this.flipDeck[key].innerHTML = `
        <div class="flip-card">
          <div class="flip-card-wrapper">
            <div class="top block">${next.charAt(0)}</div>
            <div class="card-box">
              <div class="card-block front">${current.charAt(0)}</div>
              <div class="card-block back">${next.charAt(0)}</div>
            </div>
            <div class="bottom block">${current.charAt(0)}</div>
          </div>
        </div>
        <div class="flip-card">
          <div class="flip-card-wrapper">
            <div class="top block">${next.charAt(1)}</div>
            <div class="card-box">
              <div class="card-block front">${current.charAt(1)}</div>
              <div class="card-block back">${next.charAt(1)}</div>
            </div>
            <div class="bottom block">${current.charAt(1)}</div>
          </div>
        </div>
      `;
        this.flipDeck[key]
          .querySelectorAll(".flip-card")
          .forEach((card, index) => {
            this.controller[key].cards[index] = {
              box: card.querySelector(".card-box"),
              top: card.querySelector(".top"),
              back: card.querySelector(".back"),
              front: card.querySelector(".front"),
              bottom: card.querySelector(".bottom"),
            };
          });
      });
    }

    getNextNumber(unit) {
      switch (unit) {
        case "days":
          return "364";
        case "hours":
          return "23";
        case "minutes":
          return "59";
        case "seconds":
          return "59";
      }
    }

    updateFlipCard(unit, value) {
      const cell = this.controller[unit];
      const oldValue = JSON.parse(JSON.stringify(cell.number));
      const newValue = String(value).padStart(2, "0").split("");

      for (let i = 0; i < newValue.length; i++) {
        if (oldValue[i] !== newValue[i]) {
          this.controller[unit].number[i] = newValue[i];
          this.renderCard(cell.cards[i], newValue[i], oldValue[i]);
        }
      }
    }

    renderCard(card, newValue, oldValue) {
      const { box, top, back, bottom, front } = card;

      // 更新静态数字
      front.textContent = oldValue;
      bottom.textContent = oldValue;
      box.style.transition = "transform 0s";
      box.style.transform = "none";

      let timer = setTimeout(() => {
        box.style.transition = "transform 0.9s";
        back.textContent = newValue;
        top.textContent = newValue;
        box.style.transform =
          "perspective(var(--card-height)) rotateX(-180deg)";
        clearTimeout(timer);
      }, 100);
    }
  }
);

customElements.define(
  "footer-menu",
  class extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      const menuHeaders = this.querySelectorAll(".footer-block__menu-header");
      menuHeaders.forEach((item) => {
        item.addEventListener("click", (e) => {
          let openItem = e.target
          if (e.target.tagName !== "DIV") {
            openItem = e.target.closest("div");
          }
          if (openItem.hasAttribute("open")) {
            openItem.removeAttribute("open");
          } else {
            openItem.setAttribute("open", "");
          }
        });
      });
    }
  }
);

customElements.define(
  "product-list",
  class extends HTMLElement {
    constructor() {
      super();

      this.loadButon = this.querySelector(".load-more");
      if (!this.loadButon) return;
      this.section_id = this.loadButon.getAttribute("section-id");
      this.per_page = this.loadButon.getAttribute("per-page") || 8;
      this.container = this.querySelector("#product-grid");

      const { url, page } = this.getFetchConfig();
      this.url = url;
      this.page = page;
      this.url.searchParams.set("section_id", this.section_id);

      this.loadButon.addEventListener("click", this.loadMore.bind(this));
    }

    getFetchConfig() {
      const url = new URL(location.href);
      const page = url.searchParams.get("page") || 1;
      return { url, page };
    }

    loadMore() {
      if (
        this.loadButon.classList.contains("loading") &&
        this.loadButon.hasAttribute("disabled")
      )
        return;
      this.loadButon.classList.add("loading");
      this.url.searchParams.set("page", ++this.page);
      fetch(this.url.href)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(
            responseText,
            "text/html"
          );
          const products = html.querySelectorAll("#product-grid li");
          if (products.length < this.per_page) {
            this.loadButon.setAttribute("disabled", "");
            this.loadButon.classList.add("hidden");
          }
          this.container.append(...Array.from(products));
        })
        .finally(() => {
          this.loadButon.classList.remove("loading");
        });
    }
  }
);

customElements.define(
  "product-collect",
  class ProductCollect extends HTMLElement {
    static key = "__product_wishlist__";
    static maxLength = 20;
    static wishlistVersion = '1.2'

    constructor() {
      super();

      const getwishlistVersion = localStorage.getItem('__product_wishlist_version__');
      if (getwishlistVersion !== ProductCollect.wishlistVersion) {
        localStorage.removeItem(ProductCollect.key);
        localStorage.setItem('__product_wishlist_version__', ProductCollect.wishlistVersion);
      }
      // this.productId = this.getAttribute("product-id");
      this.productHandle = this.getAttribute("product-handle");
      this.productTitle = this.getAttribute("product-title");
      this.productImage = this.getAttribute("product-img");
      this.productUrl = this.getAttribute("product-url");
      this.productSku = this.getAttribute("product-sku");
      this.productVariantId = this.getAttribute("product-variant-id");

      if (!this.productHandle) return;
      // if (!this.productId) return;
      this.collectList = JSON.parse(
        localStorage.getItem(ProductCollect.key) || "[]"
      );
      this.collect = this.collectList.some(item => item.handle === this.productHandle);
      if (this.collect) {
        this.setAttribute("collect", "");
      } else {
        this.removeAttribute("collect");
      }

      this.addEventListener("click", this.toggleCollect.bind(this));
    }

    toggleCollect() {
      if (this.collect) {
        this.removeCollect();
      } else {
        this.addCollect();
      }

      window.dispatchEvent(new Event("wishlist:change"));
    }

    addCollect() {
      this.collect = true;
      this.setAttribute("collect", "");
      if (this.collectList.includes(this.productHandle)) return;
      this.collectList = JSON.parse(
        localStorage.getItem(ProductCollect.key) || "[]"
      );
      if (this.collectList.length >= ProductCollect.maxLength) {
        this.collectList.shift();
      }
      this.collectList.push({
        handle: this.productHandle,
        img: this.productImage || '',
        title: this.productTitle || '',
        sku: this.productSku || '',
        variantId: this.productVariantId || '',
        url: this.productUrl || '',
        qty: 1
      })
      localStorage.setItem(
        ProductCollect.key,
        JSON.stringify(this.collectList)
      );
    }

    removeCollect() {
      this.collect = false;
      this.removeAttribute("collect");
      this.collectList = JSON.parse(
        localStorage.getItem(ProductCollect.key) || "[]"
      );
      this.collectList = this.collectList.filter(
        (item) => item.handle !== this.productHandle
      );
      localStorage.setItem(
        ProductCollect.key,
        JSON.stringify(this.collectList)
      );
    }
  }
);

class WishlistCountBubble extends HTMLElement {
  constructor() {
    super();

    this.wishlistKey = '__product_wishlist__'
  }

  connectedCallback() {
    this.updateCount();
    window.addEventListener("wishlist:change", (event) => {
      this.updateCount();
    });
  }

  updateCount() {
    const collectList = JSON.parse(
      localStorage.getItem(this.wishlistKey) || "[]"
    );
    const countSummary = collectList.reduce((sum, item) => sum + (item.qty || 1), 0);
    if (countSummary > 0) {
      this.textContent = countSummary;
    } else {
      this.textContent = "";
    }
  }
}

customElements.define("wishlist-count-bubble", WishlistCountBubble);

class FAQAccordion extends HTMLElement {
  constructor() {
    super();
    this.attachShadow({ mode: "open" });
    this.mode = this.getAttribute('data-mode') || 'accordion';
    const style = document.createElement("style");
    const slot = document.createElement("slot");
    this.shadowRoot.append(style, slot);
  }

  connectedCallback() {
    // Wait until the DOM is painted
    requestAnimationFrame(() => this.setupItems());
  }

  setupItems() {
    const items = this.querySelectorAll(".faq-item");

    items.forEach((item) => {
      const question = item.querySelector(".faq-question");
      const answer = item.querySelector(".faq-answer");

      let icon = item.querySelector(".toggle-icon");
      if (!icon) {
        icon = document.createElement("span");
        icon.classList.add("toggle-icon");
        question.appendChild(icon);
      }

      question.addEventListener("click", () => {
        const isOpen = answer.classList.contains("open");

        // 获取当前模式
        const mode = this.getAttribute('data-mode') || '';

        // 如果是accordion模式，在打开当前项目前关闭所有其他项目
        if (mode === 'accordion' && !isOpen) {
          const allItems = this.querySelectorAll(".faq-item");
          allItems.forEach((otherItem) => {
            if (otherItem !== item) {
              const otherAnswer = otherItem.querySelector(".faq-answer");
              const otherIcon = otherItem.querySelector(".toggle-icon");

              if (otherAnswer && otherAnswer.classList.contains("open")) {
                otherAnswer.classList.remove("open");
                if (otherIcon) otherIcon.classList.remove("rotate");
              }
            }
          });
        }

        console.log("isOpen", answer.classList);
        answer.classList.toggle("open");
        icon.classList.toggle("rotate", !isOpen);
      });
    });
  }
}

customElements.define("faq-accordion", FAQAccordion);

class ExpandableText extends HTMLElement {
  constructor() {
    super();
    this.isCollapsed = true;
    this.maxLength = parseInt(this.getAttribute('max-length')) || 220;
    this.fullText = this.getAttribute('full-text') || '';
  }

  connectedCallback() {
    this.render();
    this.setupEventListeners();
  }

  truncateText(text, maxLength) {
    if (text.length <= maxLength) return text;

    const truncated = text.substr(0, maxLength);
    const lastSpace = truncated.lastIndexOf(' ');

    return text.substr(0, lastSpace > 0 ? lastSpace : maxLength);
  }

  render() {
    const previewText = this.truncateText(this.fullText, this.maxLength);

    this.innerHTML = `
      <div class="description-preview">
        <span>${previewText}...</span>
        <button class="product__description-toggle fs-20">Read More</button>
      </div>
      <div class="description-content">
        <span>${this.fullText}</span>
        <button class="product__description-toggle fs-20">Read Less</button>
      </div>
    `;

    this.classList.add('collapsed');

    if (this.fullText.length > this.maxLength) {
      this.querySelectorAll('.product__description-toggle').forEach(button => {
        button.classList.add('visible');
      });
    }
  }

  setupEventListeners() {
    this.querySelectorAll('.product__description-toggle').forEach(button => {
      button.addEventListener('click', () => this.toggle());
    });
  }

  toggle() {
    this.classList.toggle('collapsed');
  }
}

customElements.define('expandable-text', ExpandableText);

// Cylindo's 3D viewer scripts only load on the product template (see theme.liquid) to
// avoid shipping them on every page. Quick view can inject a product's markup (including
// a <cylindo-viewer>) into the modal from any page, so load them here too if missing.
function loadCylindoScripts() {
  if (document.querySelector('script[src*="viewer-cdn.cylindo.com"]')) return;
  ['index', 'shopify', 'bar'].forEach((name) => {
    const script = document.createElement('script');
    script.type = 'module';
    script.src = `https://viewer-cdn.cylindo.com/v1/${name}.mjs`;
    document.head.appendChild(script);
  });
}

// 添加快速查看按钮的处理
class Quickview extends HTMLElement {
  constructor() {
    super();
    this.selector = '[data-drawer="quick-view-drawer"]';
    this.drawer = document.querySelector(this.selector);
    if (!this.drawer) return;
    this.data_close_drawer = this.drawer.querySelector('[data-drawer-close]');
    this.data_close_drawer.addEventListener('click', this.close.bind(this));
    this.addEventListener('click', this.onClick.bind(this));
  }

  onClick(event) {
    event.preventDefault();
    this.fetchProduct()
  }

  open() {
    if (this.drawer) {
      setTimeout(() => {
        this.drawer.classList.add('show');
      }, 200);
      setTimeout(() => {
        this.drawer.classList.add('shadow');
        document.body.style.overflow = 'hidden';
        this.data_close_drawer.tabIndex = 0;
        this.drawer.querySelector('[data-drawer-close]').focus();
        this.drawer.querySelector(".thumbnail-slider").style.setProperty('--thumbnail-height', '100% !important');

      }, 600);
      this.drawer.style.display = 'flex';
    }
  }
  close() {
    this.drawer.classList.remove('show');
    document.body.style.overflow = 'auto';

  }
  fetchProduct() {
    let sectionUrl = this.dataset.productUrl;

    if (!sectionUrl) return;
    loadCylindoScripts();
    this.loading(true);
    fetch(sectionUrl)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        // console.log('html', html);
        const productElement = html.querySelector('#MainContent > section > product-info');
        if (productElement) {
          this.drawer.querySelector('.quickview-modal__content').innerHTML = '';
          this.drawer.querySelector('.quickview-modal__content').append(productElement.cloneNode(true));
          this.open();
        }
      })
      .catch((error) => {
        console.info('Error fetching or parsing product content:', error);
      })
      .finally(() => {
        this.loading(false);
      });
  }
  loading(isLoading) {
    const loadingElement = this.querySelector('.loading__spinner');
    const clickButtonDom = this.querySelector('button')

    if (!loadingElement) {
      const loadingTemplate = document.querySelector('template#loading-template');
      if (loadingTemplate) {
        const loadingClone = loadingTemplate.content.cloneNode(true);
        if (clickButtonDom) {
          clickButtonDom.appendChild(loadingClone);
        } else {
          this.appendChild(loadingClone);
        }
      }
    }
    if (isLoading) {
      this.classList.add('loading');
    } else {
      this.classList.remove('loading');
    }
  }
}
customElements.define('quick-view', Quickview);

class ProductMediasModal extends HTMLElement {
  constructor() {
    super();
    this.mainSwiper = null;
    this.thumbsSwiper = null;
    this.isZoomed = false;
    this.init();
  }

  init() {
    // 初始化事件监听
    this.querySelector('.product-medias-modal__close').addEventListener('click', () => this.close());
    this.querySelector('.product-medias-modal__zoom').addEventListener('click', () => this.toggleZoom());
    this.querySelector('.product-medias-modal__prev').addEventListener('click', () => this.prevSlide());
    this.querySelector('.product-medias-modal__next').addEventListener('click', () => this.nextSlide());

    // 初始化Swiper
    this.initSwipers();
  }

  initSwipers() {
    this.updateThumbs(0);
    // 初始化主图Swiper
    this.mainSwiper = new Swiper(this.querySelector('.product-medias-modal__swiper'), {
      slidesPerView: 1,
      spaceBetween: 0,
      observer: true,
      observeParents: true,
    });

    // 初始化缩略图Swiper
    this.thumbsSwiper = new Swiper(this.querySelector('.product-medias-modal__thumbs-swiper'), {
      slidesPerView: 'auto',
      spaceBetween: 10,
      observer: true,
      observeParents: true,
    });

    // 同步主图和缩略图
    this.mainSwiper.on('slideChange', () => {
      const activeIndex = this.mainSwiper.activeIndex;
      this.updateThumbs(activeIndex);
    });

    // 点击缩略图切换主图
    this.querySelectorAll('.product-medias-modal__thumbs-swiper .swiper-slide').forEach((slide, index) => {
      slide.addEventListener('click', () => {
        this.mainSwiper.slideTo(index);
      });
    });
  }

  open() {
    this.classList.add('show');
    document.body.style.overflow = 'hidden';
    // 更新Swiper以确保正确显示
    if (this.mainSwiper) this.mainSwiper.update();
    if (this.thumbsSwiper) this.thumbsSwiper.update();
  }

  close() {
    this.classList.remove('show');
    document.body.style.overflow = 'auto';
    if (this.isZoomed) {
      this.toggleZoom();
    }
    this.updateMainSwiperTouchState();
  }

  toggleZoom() {
    const currentSlide = this.querySelector('.product-medias-modal__swiper .swiper-slide-active');
    currentSlide.classList.toggle('zoomed');
    this.isZoomed = !this.isZoomed;
    const zoomButton = this.querySelector('.product-medias-modal__zoom');
    zoomButton.textContent = this.isZoomed ? 'zoom out' : 'zoom in';
    this.updateMainSwiperTouchState();
  }

  updateMainSwiperTouchState() {
    if (!this.mainSwiper) return;
    const isMobile = window.innerWidth < 768;
    // 移动端放大后禁用左右滑动，恢复默认缩放后再开启
    this.mainSwiper.allowTouchMove = !(isMobile && this.isZoomed);
  }

  prevSlide() {
    if (this.mainSwiper) this.mainSwiper.slidePrev();
  }

  nextSlide() {
    if (this.mainSwiper) this.mainSwiper.slideNext();
  }

  updateThumbs(activeIndex) {
    this.querySelectorAll('.product-medias-modal__thumbs-swiper .swiper-slide').forEach((thumb, i) => {
      thumb.classList.toggle('active', i === activeIndex);
    });
  }
}

customElements.define('product-medias-modal', ProductMediasModal);


class ProductMediasModalNew extends HTMLElement {
  constructor() {
    super();
    this.mainSwiper = null;
    this.thumbsSwiper = null;
    this.mainContainer = null;
    this.isZoomed = false;
    this.zoomScale = 1;
    this.minZoomScale = 1;
    this.maxZoomScale = 3;
    this.pinchStartDistance = 0;
    this.pinchStartScale = 1;
    this.isPinching = false;
    this.rafPinchId = null;
    this.initialized = false;
    /** 放大后平移（px），仅作用于当前 active 图 */
    this.panX = 0;
    this.panY = 0;
    this.isPanning = false;
    this.panPointerId = null;
    this.panStart = { x: 0, y: 0, panX: 0, panY: 0 };
    this.allMainSlides = [];
    this.allThumbSlides = [];
    this.variantChangeUnsubscriber = null;
    this.swiperTouchDetached = false;
    this.swipeStartX = 0;
    this.swipeStartY = 0;
    this.swipeLastX = 0;
    this.swipeLastY = 0;
    this.isSwipeTracking = false;
    this.lastActiveIndex = 0;
  }

  connectedCallback() {
    if (this.initialized) return;
    this.initialized = true;
    this.init();
  }

  disconnectedCallback() {
    if (typeof this.variantChangeUnsubscriber === 'function') {
      this.variantChangeUnsubscriber();
      this.variantChangeUnsubscriber = null;
    }
  }

  init() {
    // 统一走事件委托，避免局部重渲染后事件丢失
    this.addEventListener('click', this.handleClick.bind(this));

    this.cacheOriginalSlides();
    this.applyVariantSkuFilter(this.dataset.selectedVariantSku || '');

    // 初始化Swiper
    this.initSwipers();

    this.bindVariantChange();

    // 仅在主图区域监听滚轮/触控板缩放，避免被其他区域干扰
    this.mainContainer = this.querySelector('.product-medias-modal__swiper');
    if (this.mainContainer) {
      this.mainContainer.addEventListener('wheel', this.handleWheel.bind(this), { passive: false, capture: true });
      // capture 阶段先于 Swiper 处理触摸，避免放大态时仍被切图
      this.mainContainer.addEventListener('touchstart', this.handleTouchStart.bind(this), { passive: false, capture: true });
      this.mainContainer.addEventListener('touchmove', this.handleTouchMove.bind(this), { passive: false, capture: true });
      this.mainContainer.addEventListener('touchend', this.handleTouchEnd.bind(this), { passive: true });
      this.mainContainer.addEventListener('touchcancel', this.handleTouchEnd.bind(this), { passive: true });
      this.mainContainer.addEventListener('pointerdown', this.handlePanPointerDown.bind(this));
      this.mainContainer.addEventListener('pointermove', this.handlePanPointerMove.bind(this));
      this.mainContainer.addEventListener('pointerup', this.handlePanPointerUp.bind(this));
      this.mainContainer.addEventListener('pointercancel', this.handlePanPointerUp.bind(this));
      this.mainContainer.addEventListener('dragstart', (e) => {
        if (e.target.closest('.product-medias-modal__image-wrap img')) e.preventDefault();
      });
    }
  }

  cacheOriginalSlides() {
    const mainSlides = this.querySelectorAll('.product-medias-modal__swiper .swiper-wrapper > .swiper-slide');
    const thumbSlides = this.querySelectorAll('.product-medias-modal__thumbs-swiper .swiper-wrapper > .swiper-slide');
    this.allMainSlides = Array.from(mainSlides).map((slide) => slide.cloneNode(true));
    this.allThumbSlides = Array.from(thumbSlides).map((slide) => slide.cloneNode(true));
  }

  bindVariantChange() {
    if (typeof subscribe !== 'function' || !PUB_SUB_EVENTS?.variantChange) return;
    this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
      const variant = event?.data?.variant;
      const sectionId = String(event?.data?.sectionId || '');
      const ownSectionId = String(this.dataset.sectionId || '');
      if (ownSectionId && sectionId && ownSectionId !== sectionId) return;
      this.applyVariantSkuFilter(variant?.sku || '');
    });
  }

  applyVariantSkuFilter(variantSku) {
    const mainWrapper = this.querySelector('.product-medias-modal__swiper .swiper-wrapper');
    const thumbsWrapper = this.querySelector('.product-medias-modal__thumbs-swiper .swiper-wrapper');
    if (!mainWrapper || !thumbsWrapper || !this.allMainSlides.length) return;

    const normalizedVariantSku = String(variantSku || '').trim();
    this.dataset.selectedVariantSku = normalizedVariantSku;

    const matchedMainSlides = this.allMainSlides.filter((slide) => {
      const mediaSku = String(slide.getAttribute('data-media-sku') || '').trim();
      return mediaSku === '' || mediaSku === normalizedVariantSku;
    });

    const nextMainSlides = matchedMainSlides.length ? matchedMainSlides : this.allMainSlides;
    const allowedMediaIds = new Set(nextMainSlides.map((slide) => String(slide.getAttribute('data-media-id') || '')));
    const nextThumbSlides = this.allThumbSlides.filter((slide) => {
      const mediaId = String(slide.getAttribute('data-media-id') || '');
      return allowedMediaIds.has(mediaId);
    });

    mainWrapper.innerHTML = '';
    nextMainSlides.forEach((slide) => mainWrapper.appendChild(slide.cloneNode(true)));
    thumbsWrapper.innerHTML = '';
    nextThumbSlides.forEach((slide) => thumbsWrapper.appendChild(slide.cloneNode(true)));

    this.reInitSwipers();
  }

  reInitSwipers() {
    if (this.mainSwiper) {
      this.mainSwiper.destroy(true, true);
      this.mainSwiper = null;
    }
    if (this.thumbsSwiper) {
      this.thumbsSwiper.destroy(true, true);
      this.thumbsSwiper = null;
    }
    this.swiperTouchDetached = false;
    this.initSwipers();
  }

  initSwipers() {
    this.updateThumbs(0);
    const mainContainer = this.querySelector('.product-medias-modal__swiper');
    const thumbsContainer = this.querySelector('.product-medias-modal__thumbs-swiper');
    if (!mainContainer) return;

    // 初始化主图Swiper
    this.mainSwiper = new Swiper(mainContainer, {
      slidesPerView: 1,
      spaceBetween: 0,
      loop: false,
      speed: 320,
      observer: true,
      observeParents: true,
    });

    // 初始化缩略图Swiper
    if (thumbsContainer) {
      this.thumbsSwiper = new Swiper(thumbsContainer, {
        slidesPerView: 'auto',
        spaceBetween: 10,
        observer: true,
        observeParents: true,
      });
    }

    // 同步主图和缩略图
    this.mainSwiper.on('slideChange', () => {
      const activeIndex = this.mainSwiper.activeIndex;
      if (this.shouldLockSlideWhenZoomed() && activeIndex !== this.lastActiveIndex) {
        this.mainSwiper.slideTo(this.lastActiveIndex, 0, false);
        return;
      }
      this.lastActiveIndex = activeIndex;
      this.updateThumbs(activeIndex);
      this.panX = 0;
      this.panY = 0;
      if (this.isZoomed) {
        this.applyZoomToActiveImage();
      }
    });
    this.mainSwiper.on('transitionEnd', () => {
      this.updateThumbs(this.mainSwiper.activeIndex);
    });

    this.syncMainSwiperTouchState();
  }

  open() {
    this.openAtMedia();
  }

  openAtMedia(mediaId) {
    this.applyVariantSkuFilter(this.dataset.selectedVariantSku || '');
    this.classList.add('show');
    document.body.style.overflow = 'hidden';
    this.syncMainSwiperTouchState();
    // 更新Swiper以确保正确显示
    if (this.mainSwiper) this.mainSwiper.update();
    if (this.thumbsSwiper) this.thumbsSwiper.update();
    const targetIndex = this.getMediaIndexById(mediaId);
    if (targetIndex > -1 && this.mainSwiper) {
      this.mainSwiper.slideTo(targetIndex, 0);
      this.lastActiveIndex = targetIndex;
      this.updateThumbs(targetIndex);
    } else if (this.mainSwiper) {
      this.lastActiveIndex = this.mainSwiper.activeIndex || 0;
    }
  }

  show(mediaId) {
    this.openAtMedia(mediaId);
  }

  getMediaIndexById(mediaId) {
    if (!mediaId) return -1;
    const mediaIdStr = String(mediaId);
    const slides = this.querySelectorAll('.product-medias-modal__swiper .swiper-slide:not(.swiper-slide-duplicate)');
    for (let i = 0; i < slides.length; i += 1) {
      if (slides[i].getAttribute('data-media-id') === mediaIdStr) {
        return i;
      }
    }
    return -1;
  }

  close() {
    this.classList.remove('show');
    document.body.style.overflow = 'auto';
    if (this.isZoomed) {
      this.toggleZoom();
    }
    this.resetAllImageScale();
  }

  toggleZoom() {
    const currentSlide = this.querySelector('.product-medias-modal__swiper .swiper-slide-active');
    if (!currentSlide) return;
    if (this.isZoomed) {
      currentSlide.classList.remove('zoomed');
      this.isZoomed = false;
      this.zoomScale = 1;
      this.panX = 0;
      this.panY = 0;
      this.applyZoomToActiveImage();
      this.syncMainSwiperTouchState();
    } else {
      currentSlide.classList.add('zoomed');
      this.isZoomed = true;
      this.zoomScale = 1.6;
      this.panX = 0;
      this.panY = 0;
      this.applyZoomToActiveImage();
      this.syncMainSwiperTouchState();
    }
    this.classList.toggle('is-zoomed', this.isZoomed);
    const zoomButton = this.querySelector('.product-medias-modal__zoom');
    if (zoomButton) {
      const zoomLabel = zoomButton.querySelector('.product-medias-modal__zoom-label');
      if (zoomLabel) {
        zoomLabel.textContent = this.isZoomed ? 'zoom out' : 'zoom in';
      } else {
        zoomButton.textContent = this.isZoomed ? 'zoom out' : 'zoom in';
      }
    }
  }

  syncMainSwiperTouchState() {
    if (!this.mainSwiper) return;
    // 主图切换统一不使用 Swiper 手势（PC 端仅允许箭头切换，移动端走自定义 touch 逻辑）
    const shouldAllow = false;
    this.mainSwiper.allowTouchMove = shouldAllow;
    this.mainSwiper.params.allowTouchMove = shouldAllow;
    if (shouldAllow) {
      if (this.swiperTouchDetached && typeof this.mainSwiper.attachEvents === 'function') {
        this.mainSwiper.attachEvents();
        this.swiperTouchDetached = false;
      }
      this.mainSwiper.enable();
    } else {
      if (!this.swiperTouchDetached && typeof this.mainSwiper.detachEvents === 'function') {
        this.mainSwiper.detachEvents();
        this.swiperTouchDetached = true;
      }
      // 移动端默认态仍需允许程序化 slideTo/slideNext，因此仅在放大态禁用实例
      if (this.isZoomed) {
        this.mainSwiper.disable();
      } else {
        this.mainSwiper.enable();
      }
    }
  }

  shouldLockSlideWhenZoomed() {
    return this.isZoomed && window.innerWidth >= 768;
  }

  prevSlide() {
    if (this.shouldLockSlideWhenZoomed()) return;
    if (!this.mainSwiper) return;
    const slideCount = this.mainSwiper.slides?.length || 0;
    if (!slideCount) return;
    const currentIndex = this.mainSwiper.activeIndex || 0;
    const targetIndex = currentIndex <= 0 ? slideCount - 1 : currentIndex - 1;
    this.mainSwiper.slideTo(targetIndex);
    this.lastActiveIndex = targetIndex;
  }

  nextSlide() {
    if (this.shouldLockSlideWhenZoomed()) return;
    if (!this.mainSwiper) return;
    const slideCount = this.mainSwiper.slides?.length || 0;
    if (!slideCount) return;
    const currentIndex = this.mainSwiper.activeIndex || 0;
    const targetIndex = currentIndex >= slideCount - 1 ? 0 : currentIndex + 1;
    this.mainSwiper.slideTo(targetIndex);
    this.lastActiveIndex = targetIndex;
  }

  updateThumbs(activeIndex) {
    const thumbs = this.querySelectorAll('.product-medias-modal__thumbs-swiper .swiper-slide');
    thumbs.forEach((thumb, i) => {
      thumb.classList.toggle('active', i === activeIndex);
    });

    const activeThumb = thumbs[activeIndex];
    if (activeThumb) {
      const isMobile = window.innerWidth < 768;
      activeThumb.scrollIntoView({
        behavior: 'smooth',
        block: isMobile ? 'nearest' : 'center',
        inline: isMobile ? 'center' : 'nearest',
      });
    }
  }

  handleClick(event) {
    const closeButton = event.target.closest('.product-medias-modal__close');
    if (closeButton) {
      this.close();
      return;
    }

    const backButton = event.target.closest('.product-medias-modal__back');
    if (backButton) {
      this.close();
      return;
    }

    const zoomButton = event.target.closest('.product-medias-modal__zoom');
    if (zoomButton) {
      this.toggleZoom();
      return;
    }

    const prevButton = event.target.closest('.product-medias-modal__prev');
    if (prevButton) {
      this.prevSlide();
      return;
    }

    const nextButton = event.target.closest('.product-medias-modal__next');
    if (nextButton) {
      this.nextSlide();
      return;
    }

    const thumbSlide = event.target.closest('.product-medias-modal__thumbs-swiper .swiper-slide');
    if (thumbSlide && this.mainSwiper) {
      if (this.shouldLockSlideWhenZoomed()) return;
      const thumbs = Array.from(this.querySelectorAll('.product-medias-modal__thumbs-swiper .swiper-slide'));
      const index = thumbs.indexOf(thumbSlide);
      if (index > -1) this.mainSwiper.slideTo(index, 200);
    }
  }

  handleWheel(event) {
    if (!this.mainContainer || !this.mainContainer.contains(event.target)) return;

    const activeSlide = this.querySelector('.product-medias-modal__swiper .swiper-slide-active');
    if (!activeSlide) return;
    const activeImage = activeSlide.querySelector('.product-medias-modal__image-wrap img');
    if (!activeImage) return;

    event.preventDefault();
    event.stopPropagation();

    const delta = event.deltaMode === 1 ? event.deltaY * 12 : event.deltaY;

    // 未点击按钮时，首次滚轮也直接进入 zoom in 状态（与按钮行为一致）
    if (!this.isZoomed) {
      // 默认状态下只允许向上滚轮进入 zoom，向下滚轮保持默认态
      if (delta >= 0) return;
      this.isZoomed = true;
      this.zoomScale = 1.6;
      activeSlide.classList.add('zoomed');
      this.classList.add('is-zoomed');
      this.syncMainSwiperTouchState();
      const zoomLabel = this.querySelector('.product-medias-modal__zoom-label');
      if (zoomLabel) zoomLabel.textContent = 'zoom out';
    }

    // 触控板 pinch 常见为 ctrlKey + wheel，这里给更平滑的缩放步进
    const speed = event.ctrlKey ? 0.0025 : 0.0018;
    const nextScale = this.zoomScale * (1 - delta * speed);
    this.zoomScale = Math.max(this.minZoomScale, Math.min(this.maxZoomScale, nextScale));

    if (this.zoomScale <= 1.01) {
      this.zoomScale = 1;
      this.isZoomed = false;
      this.panX = 0;
      this.panY = 0;
      activeSlide.classList.remove('zoomed');
      this.classList.remove('is-zoomed');
      this.syncMainSwiperTouchState();
      const zoomButton = this.querySelector('.product-medias-modal__zoom-label');
      if (zoomButton) zoomButton.textContent = 'zoom in';
    }

    this.applyZoomToActiveImage();
  }

  handlePanPointerDown(event) {
    if (!this.isZoomed || this.isPinching) return;
    const img = event.target.closest('.product-medias-modal__image-wrap img');
    if (!img) return;
    const slide = img.closest('.product-medias-modal__swiper .swiper-slide');
    if (!slide || !slide.classList.contains('swiper-slide-active')) return;
    if (event.pointerType === 'mouse' && event.button !== 0) return;

    event.preventDefault();
    this.isPanning = true;
    this.panPointerId = event.pointerId;
    try {
      img.setPointerCapture(event.pointerId);
    } catch (_) {}
    this.panStart = { x: event.clientX, y: event.clientY, panX: this.panX, panY: this.panY };
    this.classList.add('is-panning');
  }

  handlePanPointerMove(event) {
    if (!this.isPanning || event.pointerId !== this.panPointerId) return;
    event.preventDefault();
    const dx = event.clientX - this.panStart.x;
    const dy = event.clientY - this.panStart.y;
    this.panX = this.panStart.panX + dx;
    this.panY = this.panStart.panY + dy;
    this.applyZoomToActiveImage();
  }

  handlePanPointerUp(event) {
    if (this.panPointerId == null || event.pointerId !== this.panPointerId) return;
    this.isPanning = false;
    this.panPointerId = null;
    this.classList.remove('is-panning');
  }

  handleTouchStart(event) {
    if (event.touches.length === 1) {
      const touch = event.touches[0];
      this.swipeStartX = touch.clientX;
      this.swipeStartY = touch.clientY;
      this.swipeLastX = touch.clientX;
      this.swipeLastY = touch.clientY;
      this.isSwipeTracking = true;
    } else {
      this.isSwipeTracking = false;
    }

    if (this.isZoomed && event.touches.length === 1) {
      // 放大态单指触摸直接拦截，阻止Swiper开始横向滑动
      event.preventDefault();
      event.stopPropagation();
      if (typeof event.stopImmediatePropagation === 'function') {
        event.stopImmediatePropagation();
      }
      this.syncMainSwiperTouchState();
      return;
    }

    if (event.touches.length !== 2) return;
    const activeSlide = this.querySelector('.product-medias-modal__swiper .swiper-slide-active');
    if (!activeSlide) return;
    const activeImage = activeSlide.querySelector('.product-medias-modal__image-wrap img');
    if (!activeImage) return;

    event.preventDefault();
    if (this.isPanning) {
      this.isPanning = false;
      this.panPointerId = null;
      this.classList.remove('is-panning');
    }
    this.isPinching = true;
    this.classList.add('is-pinching');
    this.syncMainSwiperTouchState();
    this.pinchStartDistance = this.getTouchDistance(event.touches[0], event.touches[1]);
    this.pinchStartScale = this.zoomScale;
  }

  handleTouchMove(event) {
    if (this.isSwipeTracking && event.touches.length === 1) {
      const touch = event.touches[0];
      this.swipeLastX = touch.clientX;
      this.swipeLastY = touch.clientY;
    }

    if (this.isZoomed && !this.isPinching && event.touches.length === 1) {
      // 单指移动放大图时，阻止Swiper接管手势导致切图
      event.preventDefault();
      event.stopPropagation();
      if (typeof event.stopImmediatePropagation === 'function') {
        event.stopImmediatePropagation();
      }
      return;
    }

    if (!this.isPinching || event.touches.length !== 2) return;
    const activeSlide = this.querySelector('.product-medias-modal__swiper .swiper-slide-active');
    if (!activeSlide) return;
    const activeImage = activeSlide.querySelector('.product-medias-modal__image-wrap img');
    if (!activeImage) return;

    event.preventDefault();
    const distance = this.getTouchDistance(event.touches[0], event.touches[1]);
    if (!this.pinchStartDistance) return;
    const ratio = distance / this.pinchStartDistance;
    let nextScale = this.pinchStartScale * ratio;
    nextScale = Math.max(this.minZoomScale, Math.min(this.maxZoomScale, nextScale));

    if (!this.isZoomed && nextScale > 1.02) {
      this.isZoomed = true;
      activeSlide.classList.add('zoomed');
      this.classList.add('is-zoomed');
      this.syncMainSwiperTouchState();
      const zoomLabel = this.querySelector('.product-medias-modal__zoom-label');
      if (zoomLabel) zoomLabel.textContent = 'zoom out';
    }

    this.zoomScale = nextScale;

    if (this.zoomScale <= 1.01) {
      this.zoomScale = 1;
      this.isZoomed = false;
      this.panX = 0;
      this.panY = 0;
      activeSlide.classList.remove('zoomed');
      this.classList.remove('is-zoomed');
      this.syncMainSwiperTouchState();
      const zoomLabel = this.querySelector('.product-medias-modal__zoom-label');
      if (zoomLabel) zoomLabel.textContent = 'zoom in';
    }
    if (this.rafPinchId) cancelAnimationFrame(this.rafPinchId);
    this.rafPinchId = requestAnimationFrame(() => {
      this.applyZoomToActiveImage();
    });
  }

  handleTouchEnd(event) {
    if (this.isSwipeTracking && !this.isPinching && !this.isZoomed) {
      const dx = this.swipeLastX - this.swipeStartX;
      const dy = this.swipeLastY - this.swipeStartY;
      const absDx = Math.abs(dx);
      const absDy = Math.abs(dy);
      const minSwipeDistance = 40;
      const horizontalDominanceRatio = 1.2;

      if (absDx >= minSwipeDistance && absDx > absDy * horizontalDominanceRatio) {
        if (dx < 0) {
          this.nextSlide();
        } else {
          this.prevSlide();
        }
      }
    }
    this.isSwipeTracking = false;

    if (event.touches.length < 2) {
      this.isPinching = false;
      this.pinchStartDistance = 0;
      this.classList.remove('is-pinching');
      if (this.rafPinchId) {
        cancelAnimationFrame(this.rafPinchId);
        this.rafPinchId = null;
      }
      this.syncMainSwiperTouchState();
      if (this.isZoomed) this.applyZoomToActiveImage();
    }
  }

  getTouchDistance(touchA, touchB) {
    const dx = touchA.clientX - touchB.clientX;
    const dy = touchA.clientY - touchB.clientY;
    return Math.hypot(dx, dy);
  }

  clampPanForActiveImage() {
    const activeSlide = this.querySelector('.product-medias-modal__swiper .swiper-slide-active');
    if (!activeSlide) return;
    const wrap = activeSlide.querySelector('.product-medias-modal__image-wrap');
    const img = wrap?.querySelector('img');
    if (!wrap || !img) return;
    const s = this.zoomScale;
    const vw = img.offsetWidth * s;
    const vh = img.offsetHeight * s;
    const cw = wrap.clientWidth;
    const ch = wrap.clientHeight;
    const maxPanX = Math.max(0, (vw - cw) / 2);
    const maxPanY = Math.max(0, (vh - ch) / 2);
    this.panX = Math.max(-maxPanX, Math.min(maxPanX, this.panX));
    this.panY = Math.max(-maxPanY, Math.min(maxPanY, this.panY));
  }

  applyZoomToActiveImage() {
    const activeImage = this.querySelector('.product-medias-modal__swiper .swiper-slide-active .product-medias-modal__image-wrap img');
    if (!activeImage) return;
    if (this.isZoomed && this.zoomScale > 1.001) {
      this.clampPanForActiveImage();
    }
    const sc = this.isZoomed ? this.zoomScale : 1;
    const px = this.isZoomed ? this.panX : 0;
    const py = this.isZoomed ? this.panY : 0;
    activeImage.style.setProperty('transform', `translate(${px}px, ${py}px) scale(${sc})`, 'important');
  }

  resetAllImageScale() {
    this.panX = 0;
    this.panY = 0;
    this.querySelectorAll('.product-medias-modal__image-wrap img').forEach((img) => {
      img.style.removeProperty('transform');
    });
    this.zoomScale = 1;
    this.isZoomed = false;
    this.classList.remove('is-zoomed');
    this.syncMainSwiperTouchState();
  }
}

customElements.define('product-medias-modal-new', ProductMediasModalNew);
class ProductModalOpener extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', this.onClick.bind(this));
    // click browser back button to close modal
    window.addEventListener('popstate', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (!modal || typeof modal.close !== 'function') return;
      modal.close();
    });
  }

  onClick(event) {
    event.preventDefault();
    const modal = document.querySelector(this.getAttribute('data-modal'));
    if (!modal || typeof modal.show !== 'function') return;
    // add param to url for go back support
    const mediaId = this.getAttribute('data-media-id');
    if (mediaId) {
      const url = new URL(window.location);
      url.searchParams.set('popup_media_id', mediaId);
      window.history.pushState({}, '', url);
    }
    modal.show(this.getAttribute('data-media-id'));
  }
}
customElements.define('product-modal-opener', ProductModalOpener);

const headerMenuPc = document.querySelector('header .header__inline-menu')
if (headerMenuPc) {
  const menuItems = headerMenuPc.querySelectorAll('details')

  menuItems.forEach(item => {
    const summary = item.querySelector('summary')
    if (summary) {
      summary.addEventListener('click', e => {
        e.preventDefault()
        const link = summary.getAttribute('data-href')
        if (link) window.location.href = link
      })
    }
    item.addEventListener('mouseenter', () => {
      item.setAttribute('open', '');

      const pcHeader = document.querySelector('.section-header.shopify-section-group-header-group');
      const headerRect = document.querySelector('.header-wrapper').getBoundingClientRect();
      const itemRect = item.getBoundingClientRect();
      const dropdownMenu = item.querySelector('.mega-menu__content');
      const cartNotification = document.querySelector('cart-notification');
      
      // Close cart notification if open
      if (cartNotification && typeof cartNotification.close === 'function') {
        cartNotification.close()
      }
      if (pcHeader) {
        pcHeader.classList.add('dropdown-opened');
      }
      if (!dropdownMenu) return;
      dropdownMenu.style.left = 'unset';
      dropdownMenu.style.right = 'unset';
      dropdownMenu.style.transform = 'unset';

      const dropdownRect = dropdownMenu.getBoundingClientRect();
      // To prevent overflow right
      // console.log('dropdownRect', dropdownRect, window.innerWidth);
      if (dropdownRect.left + dropdownRect.width + 20 > window.innerWidth) {
        dropdownMenu.style.left = 'unset';
        dropdownMenu.style.right = '0';
      } else {
        dropdownMenu.style.left = 'unset';
        dropdownMenu.style.right = 'unset';
        if (dropdownRect.left > window.innerWidth / 2) {
          dropdownMenu.style.transform = 'translateX(calc(-50% + ' + itemRect.width / 2 + 'px))';
        }
      }
      item.querySelector('.mega-menu__content').style.top = (itemRect.top - headerRect.top) + itemRect.height - 1 + 'px';
      
    });
    item.addEventListener('mouseleave', () => {
      item.removeAttribute('open')
      const pcHeader = document.querySelector('.section-header.shopify-section-group-header-group');
      if (pcHeader) {
        pcHeader.classList.remove('dropdown-opened');
      }
    });
  });
}

class HeaderZipcodeLocator extends HTMLElement {
  constructor() {
    super();
    this.details = this.querySelector('details');
    this.summary = this.querySelector('summary')
    this.overlay = this.querySelector('.overlay');
    this.closeButton = this.querySelector('.icon-close-small');

    this.overlay.addEventListener('click', this.close.bind(this));
    this.closeButton.addEventListener('click', this.close.bind(this));
    this.summary.addEventListener('click', this.summaryClick.bind(this));

    this.init();
  }

  checkRegionIdFromUrl() {
    const urlParams = new URLSearchParams(window.location.search);
    const regionId = urlParams.get('region_id');
    
    if (!regionId) {
      return null;
    }
    
    const zipcode = window.REGION_ZIPCODES[regionId];
    
    if (zipcode) {
      console.log('Region ID detected:', regionId, '→ Zipcode:', zipcode);
      return zipcode;
    } else {
      console.warn('Unknown region_id:', regionId);
      return null;
    }
  }

  init() {
    const form = this.querySelector('.header-zipcode-locator__form');
    const input = this.querySelector('.header-zipcode-locator__input');
    const submitButton = this.querySelector('button[type="submit"]');
    const closeButton = this.querySelector('.header-zipcode-locator__close');
    const errorMessage = this.querySelector('.header-zipcode-locator__error');
    const emptyText = this.querySelector('.header-zipcode-locator__result--empty');
    const storeNameContainer = this.querySelector('[data-store-name]');
    const zipCodeContainer = this.querySelector('[data-zipcode]');
    const details = this.querySelector('details');

    // Load stored data from cookies
    const storedZipCode = getCookie('mor_zipcode');
    const storedStoreCode = getCookie('mor_store_code');
    const storedStoreName = getCookie('mor_store_name');

    const regionZipcode = this.checkRegionIdFromUrl();

    if (regionZipcode) {
    // Region ID found - use it
      if(zipCodeContainer) zipCodeContainer.textContent = regionZipcode;
      console.log('Using zipcode from region_id:', regionZipcode);
      input.value = regionZipcode;
      submitZipCode(regionZipcode);
    } else {
      if (storedZipCode && (storedStoreCode || storeCodeFromUrl) ) {
        // Display store name if available, otherwise zip code
        if (emptyText) emptyText.textContent = storedStoreName || storedZipCode;
        if (storeNameContainer) storeNameContainer.textContent = decodeURI(storedStoreName) || '';
        // Pre-fill input with stored zip code
        input.value = storedZipCode;
        if(zipCodeContainer) zipCodeContainer.textContent = storedZipCode;

        // Update current zipcode on store locator page
        const storeLocatorZipDom = document.querySelector('.store-locator__my-store-info .selected-zipcode span');
        if (storeLocatorZipDom) {
          storeLocatorZipDom.textContent = storedZipCode;
        }
        updatePdpShippingMethods(storedZipCode);

        if (storeCodeFromUrl) {
          const _store = getStoreByCode(storeCodeFromUrl)
          afterStoreLocated(_store)
        }
      } else {
        // No stored zip code, attempt geolocation
        getUserLocation();
      }
    }

    // Geolocation functions
    async function getUserLocation() {
      try {
        console.log('Attempting to get user location...');

        // Step 1: Get latitude and longitude using Google Geolocation API
        const geoController = new AbortController();
        const geoTimeoutId = setTimeout(() => geoController.abort(), 4000);
        const geoResponse = await fetch(`https://www.googleapis.com/geolocation/v1/geolocate?key=${window.MOR_GOOGLE_MAPS_KEY}`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          signal: geoController.signal
        });
        clearTimeout(geoTimeoutId);

        if (!geoResponse.ok) {
          throw new Error('Geolocation API request failed');
        }

        const geoData = await geoResponse.json();
        const { lat, lng } = geoData.location;

        console.log('Location coordinates:', lat, lng);

        // Step 2: Get postal code from coordinates using Google Geocoding API
        const geocodeController = new AbortController();
        const geocodeTimeoutId = setTimeout(() => geocodeController.abort(), 4000);
        const geocodeResponse = await fetch(
          `https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${lng}&key=${window.MOR_GOOGLE_MAPS_KEY}&result_type=postal_code`,
          { signal: geocodeController.signal }
        );
        clearTimeout(geocodeTimeoutId);

        if (!geocodeResponse.ok) {
          throw new Error('Geocoding API request failed');
        }

        const geocodeData = await geocodeResponse.json();

        if (geocodeData.status === 'OK' && geocodeData.results.length > 0) {
          // Extract postal code from the results
          const postalCodeComponent = geocodeData.results[0].address_components.find(
            component => component.types.includes('postal_code')
          );

          if (postalCodeComponent) {
            const zipCode = postalCodeComponent.long_name;
            console.log('Detected zip code:', zipCode);

            // Automatically submit the detected zip code
            input.value = zipCode;
            setCookie('mor_store_code', zipCode);
            await submitZipCode(zipCode);
          } else {
            console.warn('No postal code found in geocoding results');
          }
        } else {
          console.warn('Geocoding returned no results');
        }
      } catch (error) {
        console.error('Error getting user location:', error);
        // Silently fail - user can manually enter zip code
        setDefaultLocation();
      }
    }

    function setDefaultLocation () {
      const defaultStoreCode = 'XX';
      const defaultStore = getStoreByCode(defaultStoreCode);
      if (!defaultStore) {
        console.error('Default store not found for code:', defaultStoreCode);
        return;
      }
      input.value = defaultStore['zip-cd'];
      setCookie('mor_zipcode', defaultStore['zip-cd']);
      afterStoreLocated(defaultStore);
    }

    async function submitZipCode(zipCode) {
      if (!zipCode) return;

      // Normalize to first 5 digits only (handles formats like "98144-3008")
      const normalizedZip = zipCode.substring(0, 5);

      try {
        let data = null;
        let storeName = '';

        // If URL has store parameter, use store info from StoreListGlobal
        if (storeCodeFromUrl) {
          let storeInfo = null;
          if (typeof getStoreByCode === 'function') {
            storeInfo = getStoreByCode(storeCodeFromUrl);
          }
          if ((!storeInfo || storeInfo === 'Out of delivery area') && Array.isArray(StoreListGlobal)) {
            storeInfo = StoreListGlobal.find(s => s['store-cd'] === storeCodeFromUrl);
          }

          if (storeInfo && typeof storeInfo === 'object' && storeInfo['store-cd']) {
            storeName = storeInfo['store-name'] || (typeof getStoreName === 'function' ? getStoreName(storeInfo['store-cd']) : '');
            data = {
              errorCode: "200",
              storeCode: storeInfo['store-cd'],
              zipCode: storeInfo['zip-cd'] || normalizedZip,
              warehouseCode: storeInfo['region-cd'] || storeInfo['warehouse-code'] || ''
            };
          }
        }

        if (!data) {
          // Call the locate API
          const response = await fetch('https://gers.production.mor.merce.io/store/locate', {
            method: 'POST',
            headers: {
              'Accept': 'application/json, text/plain, */*',
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              storeOrZipCode: normalizedZip
            })
          });

          if (!response.ok) {
            throw new Error('API request failed');
          }

          data = await response.json();
          // Get store name based on store code
          storeName = getStoreName(data.storeCode);
        }

        // Check if the response is successful
        if (data.errorCode === "200" && data.storeCode) {
          if (!storeName) {
            storeName = getStoreName(data.storeCode);
          }

          // Store the data in cookies
          setCookie('mor_zipcode', data.zipCode);
          setCookie('mor_store_name', storeName);
          setCookie('mor_warehouse_code', data.warehouseCode);
          setCookie('mor_store_code', data.storeCode);

          // Trigger price update after cookies are set
          try {
            updateStorePrices();
          } catch (error) {
            console.error('Error updating store prices:', error);
          }

          // Trigger product stock status update after cookies are set
          try {
            updateProductStockStatus();
          } catch (error) {
            console.error('Error updating product stock status:', error);
          }

          try {
            updateNearestShowroom()
          } catch (error) {
            console.error('Error updating nearest showroom:', error);
          }
          
          // update PDP shipping methods zipcode
          try {
            updatePdpShippingMethods(data.zipCode);
          } catch (error) {
            console.error('Error updating PDP shipping methods:', error);
          }
          const pcHeaderStoreNameDom = document.querySelector('.announcement-bar-section .utility-bar__grid header-zipcode-locator [data-store-name]');
          if (pcHeaderStoreNameDom) {
            pcHeaderStoreNameDom.textContent = storeName;
          }
          const pcHeaderZipcodeDom = document.querySelector('.announcement-bar-section .utility-bar__grid header-zipcode-locator [data-zipcode]');
          if (pcHeaderZipcodeDom) {
            pcHeaderZipcodeDom.textContent = data.zipCode;
          }

          // Update the display with store name
          if(emptyText) emptyText.textContent = storeName;

          if (document.querySelector('.header__store-locator .zip-code')) {
            document.querySelector('.header__store-locator .zip-code').textContent = data.zipCode;
          }

          // Update cart with store code attribute
          await updateCartAttribute(data.zipCode, data.storeCode);

          // Update on display status on PDP
          updatePdpOnDisplay()

          // Update the store locator page with the new zip code and store information
          updateStoreLocatorPage(data.zipCode, data.storeCode);

          const storeLocatorZipDom = document.querySelector('.store-locator__my-store-info .selected-zipcode span');
          if (storeLocatorZipDom) {
            storeLocatorZipDom.textContent = data.zipCode;
          }

          // update display store filter on PLP
          const nearStoreFilterDom = document.querySelector('aside near-store-filter');
          if (nearStoreFilterDom) {
            nearStoreFilterDom.querySelector('custom-switcher').dispatchEvent(new CustomEvent('switcher-toggle', {
              detail: {state: true}
            }));
            
            const nearStoreNameDoms = document.querySelectorAll('near-store-filter [data-store-name]');
            nearStoreNameDoms.forEach(dom => {
              dom.textContent = storeName;
            });
          }
          console.log('Store code saved from geolocation:', data.storeCode);
        } else {
          console.log('Geolocated zip code is outside delivery area');
        }
      } catch (error) {
        console.error('Error submitting geolocated zip code:', error);
      }
    }

    // Handle form submission
    form.addEventListener('submit', async (e) => {
      e.preventDefault();

      const zipCode = input.value.trim();

      if (!zipCode) {
        showError('Please enter a zip code');
        return;
      }

      // Disable button during request
      submitButton.disabled = true;
      submitButton.textContent = '...';

      try {
        await submitZipCode(zipCode);

        // Hide error messages
        hideError();

        // Close the dropdown
        details.open = false;
        document.querySelector('body').classList.remove('disabled-scroll');

        // re-render zipcode and store name in the header
        if(zipCodeContainer) zipCodeContainer.textContent = zipCode;
        const storedStoreName = getCookie('mor_store_name');
        if (storeNameContainer) storeNameContainer.textContent = decodeURI(storedStoreName) || zipCode;
      } catch (error) {
        console.error('Error fetching location:', error);
        showError('Error validating zip code. Please try again.');
      } finally {
        // Re-enable button
        submitButton.disabled = false;
        submitButton.textContent = 'GO';
      }
    });

    // Handle close button
    if (closeButton) {
      closeButton.addEventListener('click', () => {
        details.open = false;
        document.querySelector('body').classList.remove('disabled-scroll');
      });
    }

    function updateProductStockStatus() {
      console.log('Updating product stock status...');

      // Find all product-form elements on the page
      const productFormElements = document.querySelectorAll('product-stock');

      if (productFormElements.length === 0) {
        console.log('No product-form elements found on page');
        return;
      }

    // Trigger stock status update for each element
    productFormElements.forEach(element => {
      try {
        element.storeCode = getCookie('mor_store_code') || (typeof storeCodeFromUrl !== 'undefined' ? storeCodeFromUrl : '') || '';
        if (typeof element.getCurrentStoreStockStatus === 'function') {
          element.stockStatus = element.getCurrentStoreStockStatus();
        }
        if (typeof element.updateStockStatus === 'function') {
          element.updateStockStatus();
        }
      } catch (e) {
        console.error('Error updating product stock status:', e);
      }
    });
    }

    async function updateCartAttribute(zipcode, storeCode) {
      try {
        const response = await fetch('/cart/update.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            attributes: {
              'mor_zipcode': zipcode || '',
              'mor_store_code': storeCode || ''
            }
          })
        });

        if (!response.ok) {
          throw new Error('Failed to update cart');
        }

        const cart = await response.json();
        console.log('Cart updated with:', cart.attributes);
      } catch (error) {
        console.error('Error updating cart:', error);
      }
    }

    function showError(message) {
      if (errorMessage) {
        errorMessage.textContent = message;
        errorMessage.style.display = 'block';
      }
    }

    function hideError() {
      if (errorMessage) {
        errorMessage.style.display = 'none';
      }
    }
  
  }

  summaryClick() {
    document.querySelector('body').classList.add('disabled-scroll')
  }

  close() {
    this.details.removeAttribute('open');
    document.querySelector('body').classList.remove('disabled-scroll')
  }

  getCurrentStoreCode() {
    const storeCode = getCookie('mor_store_code');
    return storeCode || '';
  }

  getCurrentStoreZipcode() {
    const storeZipcode = getCookie('mor_zipcode');
    return storeZipcode || '';
  }

  connectedCallback() {
    const currentZipcode = this.getCurrentStoreZipcode();
    if (currentZipcode) {
      this.querySelector('.header-zipcode-locator__input').value = currentZipcode;
      if (document.querySelector('.header__store-locator--text .zip-code')) {
        document.querySelector('.header__store-locator--text .zip-code').textContent = currentZipcode;
      }
    }
  }

}
customElements.define('header-zipcode-locator', HeaderZipcodeLocator);

class ChangeZipcodePopup extends HTMLElement {
  constructor() {
    super()
  }

  showError(message) {
    if (this.errorMessageDom) {
      this.errorMessageDom.textContent = message;
      this.errorMessageDom.style.display = 'block';
    }
  }

  hideError() {
    if (this.errorMessageDom) {
      this.errorMessageDom.textContent = '';
      this.errorMessageDom.style.display = 'none';
    }
  }

  async submitZipCode(zipcode) {
    if (!zipcode) return;

    // Normalize to first 5 digits only (handles formats like "98144-3008")
    const normalizedZip = zipcode.substring(0, 5);

    if (storeCodeFromUrl) {
      let storeInfo = null;
      if (typeof getStoreByCode === 'function') {
        storeInfo = getStoreByCode(storeCodeFromUrl);
      }
      if ((!storeInfo || storeInfo === 'Out of delivery area') && Array.isArray(StoreListGlobal)) {
        storeInfo = StoreListGlobal.find(s => s['store-cd'] === storeCodeFromUrl);
      }

      afterStoreLocated(storeInfo)

      return;
    }

    try {
      let data = null;
      let storeName = '';
      
        // Call the locate API
        const response = await fetch('https://gers.production.mor.merce.io/store/locate', {
          method: 'POST',
          headers: {
            'Accept': 'application/json, text/plain, */*',
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            storeOrZipCode: normalizedZip
          })
        });

        if (!response.ok) {
          throw new Error('API request failed');
        }

        data = await response.json();
      
      // Check if the response is successful
      if (data.errorCode === "200" && data.storeCode) {
        if (!storeName && typeof getStoreName === 'function') {
          storeName = getStoreName(data.storeCode);
        }

        // Store the data in cookies
        setCookie('mor_zipcode', data.zipCode);
        setCookie('mor_store_name', storeName);
        setCookie('mor_warehouse_code', data.warehouseCode);
        setCookie('mor_store_code', data.storeCode);

        // Update cart with store code attribute
        await updateCartAttribute({
          zipcode: data.zipCode,
          storeCode: data.storeCode
        });
      } else {
        console.log('Geolocated zip code is outside delivery area');
      }
    } catch (error) {
      console.error('Error submitting geolocated zip code:', error);
    }
  }

  init() {
    const form = this.querySelector('form');
    const submitButton = this.querySelector('button[type="submit"]');
    if (!form || !submitButton) return;
    const input = form.querySelector('input[type="search"]');
    const _this = this;

    // Handle form submission
    form.addEventListener('submit', async (e) => {
      e.preventDefault();

      const zipcode = input.value.trim();

      if (!zipcode || zipcode.length > 5) {
        _this.showError('Please enter a zip code');
        return;
      }

      // Disable button during request
      submitButton.disabled = true;
      submitButton.textContent = '...';

      try {
        await _this.submitZipCode(zipcode);

        // Hide error messages
        _this.hideError();
        window.location.reload();
      } catch (error) {
        console.error('Error fetching location:', error);
        showError('Error validating zip code. Please try again.');
      } finally {
        // Re-enable button
        submitButton.disabled = false;
        submitButton.textContent = 'GO';
      }
    });
  }

  connectedCallback() {
    this.errorMessageDom = this.querySelector('.error-message')
    this.init()
  }

}
customElements.define('change-zipcode-popup', ChangeZipcodePopup)

// 自定义下拉框组件
class CustomSelect extends HTMLElement {
  constructor() {
    super();
    this.options = [];
    this.selectedValue = '';
    this.selectedText = '';
  }

  static get observedAttributes() {
    return ['value', 'options', 'placeholder'];
  }

  connectedCallback() {
    this.initializeFromAttributes();
    this.createHiddenSelect();
    this.render();
    this.setupEventListeners();
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if (oldValue !== newValue) {
      this.render();
      this.setupEventListeners();
    }
  }

  initializeFromAttributes() {
    const optionsAttr = this.getAttribute('options');
    if (optionsAttr) {
      try {
        this.options = JSON.parse(optionsAttr);
      } catch (e) {
        console.error('Invalid options JSON:', optionsAttr);
      }
    }

    const valueAttr = this.getAttribute('value');
    if (valueAttr) {
      this.selectedValue = valueAttr;
      const selectedOption = this.options.find(opt => opt.value === valueAttr);
      if (selectedOption) {
        this.selectedText = selectedOption.text;
      }
    }
  }

  createHiddenSelect() {
    // 创建隐藏的select元素在外部DOM中
    this.hiddenSelect = document.createElement('select');
    this.hiddenSelect.style.display = 'none';
    this.hiddenSelect.name = this.getAttribute('name') || '';
    this.hiddenSelect.id = this.getAttribute('id') || '';
    
    // 复制所有属性到隐藏的select
    Array.from(this.attributes).forEach(attr => {
      if (attr.name !== 'options' && attr.name !== 'value') {
        this.hiddenSelect.setAttribute(attr.name, attr.value);
      }
    });

    // 添加选项到隐藏的select
    this.options.forEach(option => {
      const optionElement = document.createElement('option');
      optionElement.value = option.value;
      optionElement.textContent = option.text;
      if (option.value === this.selectedValue) {
        optionElement.selected = true;
      }
      this.hiddenSelect.appendChild(optionElement);
    });

    // 将隐藏的select插入到custom-select元素之后
    this.parentNode.insertBefore(this.hiddenSelect, this.nextSibling);
  }

  render() {
    this.ensureStyles();
    this.innerHTML = `
      <div class="custom-select-wrapper">
        <div class="custom-select">
          <div class="custom-select__trigger">
            <span class="custom-select__value">${this.selectedText || this.getAttribute('placeholder') || 'Please select'}</span>
            <div class="custom-select__arrow">
              <svg xmlns="http://www.w3.org/2000/svg" width="14" height="8" viewBox="0 0 14 8" fill="none">
                <path d="M13 1L7 7L1 0.999999" stroke="#616161" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </div>
          </div>
          <div class="custom-select__options">
            ${this.options.map(option => `
              <div class="custom-select__option ${option.value === this.selectedValue ? 'active' : ''}" data-value="${option.value}">
                <span>${option.text}</span>
                <svg class="check-icon" width="16" height="16" viewBox="0 0 16 16" fill="none">
                  <path d="M13.5 4.5L6 12L2.5 8.5" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </div>
            `).join('')}
          </div>
        </div>
      </div>
    `;
  }

  ensureStyles() {
    // 检查样式是否已经添加
    if (document.getElementById('custom-select-styles')) {
      return;
    }

    const style = document.createElement('style');
    style.id = 'custom-select-styles';
    style.textContent = `
      /* 自定义下拉框样式 */
      .custom-select-wrapper {
        position: relative;
        width: 100%;
      }
      
      .custom-select {
        position: relative;
        width: 100%;
      }
      
      .custom-select__trigger {
        display: flex;
        align-items: center;
        justify-content: space-between;
        border: none;
        border-radius: 8px;
        cursor: pointer;
        font-size: 12px;
        font-weight: 500;
        color: #434341;
        min-height: 44px;
        margin-left: 8px;
        text-decoration: underline;
      }
      
      .custom-select__arrow {
        margin-left: 11px;
        transition: transform 0.3s ease;
      }
      
      .custom-select.open .custom-select__arrow {
        transform: rotate(180deg);
      }
      
      .custom-select__options {
        position: absolute;
        top: 100%;
        left: auto;
        right: 0;
        background: white;
        border-radius: 4px;
        box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.10);
        z-index: 1000;
        display: none;
        overflow: hidden;
        overflow-y: auto;
        max-height: 500px;
        min-width: 200px;
        border: 1px solid #D5D5D5;
        padding: 6px;
        margin-top: 4px;
      }
      
      .custom-select.open .custom-select__options {
        display: block;
      }
      
      .custom-select__option {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0 9px;
        cursor: pointer;
        font-size: 12px;
        font-weight: 500;
        color: #434341;
        transition: background-color 0.2s ease;
        border-radius: 4px;
        margin-bottom: 9px;
      }
      
      .custom-select__option:last-child {
        border-bottom: none;
      }
      
      .custom-select__option:hover {
        background-color: #F8F8F8;
      }
      
      .custom-select__option.active {
        background-color: #E6F2F2;
        color: #537075;
      }
      
      .custom-select__option .check-icon {
        width: 16px;
        height: 16px;
        color: #537075;
        opacity: 0;
        transition: opacity 0.2s ease;
      }
      
      .custom-select__option.active .check-icon {
        opacity: 1;
      }
    `;
    
    document.head.appendChild(style);
  }

  setupEventListeners() {
    const customSelect = this.querySelector('.custom-select');
    const trigger = this.querySelector('.custom-select__trigger');
    const options = this.querySelectorAll('.custom-select__option');
    const valueSpan = this.querySelector('.custom-select__value');

    // 点击触发器打开/关闭下拉框
    trigger.addEventListener('click', (e) => {
      e.stopPropagation();
      customSelect.classList.toggle('open');
    });

    // 点击选项
    options.forEach(option => {
      option.addEventListener('click', () => {
        const value = option.getAttribute('data-value');
        const text = option.querySelector('span').textContent;

        // 更新显示的值
        valueSpan.textContent = text;

        // 更新active状态
        options.forEach(opt => opt.classList.remove('active'));
        option.classList.add('active');

        // 更新外部DOM中的隐藏select
        this.hiddenSelect.value = value;

        // 更新内部状态
        this.selectedValue = value;
        this.selectedText = text;

        // 关闭下拉框
        customSelect.classList.remove('open');

        // 触发外部DOM中隐藏select的原生change事件
        const changeEvent = new Event('change', { bubbles: true });
        this.hiddenSelect.dispatchEvent(changeEvent);
        
        // 触发input事件（用于form提交）
        const inputEvent = new Event('input', { bubbles: true });
        this.hiddenSelect.dispatchEvent(inputEvent);

        // 触发自定义change事件
        this.dispatchEvent(new CustomEvent('change', {
          detail: { value, text },
          bubbles: true
        }));
      });
    });

    // 点击外部关闭下拉框
    document.addEventListener('click', () => {
      customSelect.classList.remove('open');
    });

    // 防止下拉框内部点击事件冒泡
    customSelect.addEventListener('click', (e) => {
      e.stopPropagation();
    });
  }

  // 公共方法
  getValue() {
    return this.selectedValue;
  }

  setValue(value) {
    const option = this.options.find(opt => opt.value === value);
    if (option) {
      this.selectedValue = value;
      this.selectedText = option.text;
      this.setAttribute('value', value);
      
      // 更新外部DOM中的隐藏select
      if (this.hiddenSelect) {
        this.hiddenSelect.value = value;
      }
      
      this.render();
      this.setupEventListeners();
    }
  }

  getOptions() {
    return this.options;
  }

  setOptions(options) {
    this.options = options;
    this.setAttribute('options', JSON.stringify(options));
    this.render();
    this.setupEventListeners();
  }

  disconnectedCallback() {
    // 清理外部DOM中的隐藏select
    if (this.hiddenSelect && this.hiddenSelect.parentNode) {
      this.hiddenSelect.parentNode.removeChild(this.hiddenSelect);
    }
  }
}

customElements.define('custom-select', CustomSelect);

class ScrollToTop extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', this.scrollToTop.bind(this));
    window.addEventListener('scroll', this.toggleVisibility.bind(this));
  }
  
  scrollToTop() {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  toggleVisibility() {
    if (window.scrollY > 300) {
      this.classList.add('visible');
    }else {
      this.classList.remove('visible');
    }
  }
}

customElements.define('scroll-to-top', ScrollToTop);

class WywModal extends HTMLElement {
  constructor() {
    super();
    this.init();
  }

  init() {
    this.closeButton = this.querySelector('.wyw-modal__close');
    this.overlay = this.querySelector('.wyw-modal__overlay');
    this.closeButton ? this.closeButton.addEventListener('click', this.close.bind(this)) : null;
    this.overlay ? this.overlay.addEventListener('click', this.close.bind(this)) : null;
  }

  open() {
    this.classList.add('open');
    document.body.style.overflow = 'hidden';
  }

  close() {
    this.classList.remove('open');
    document.body.style.overflow = 'auto';
  }

  connectedCallback() {
    this.init()
    
  }
}

customElements.define('wyw-modal', WywModal);

class WywModalOpener extends HTMLElement {
  constructor() {
    super();
    this.button = this.querySelector('[data-modal-open]');
    this.button.addEventListener('click', this.onClick.bind(this));
    this.modalContent = this.querySelector('.wyw-modal-content');
  }

  onClick(event) {
    event.preventDefault();
    const modal = document.querySelector(this.button.getAttribute('data-modal'));
    console.log('modal', modal, this);
    if (modal) {
      modal.open();
    } else {
      // create modal
      const modalId = this.button.getAttribute('data-modal').replace('#', '');
      let modal = document.createElement('wyw-modal');
      modal.id = modalId;
      modal.classList.add('wyw-modal');
      modal.innerHTML = `
        <div class="wyw-modal__overlay"></div>
        <button class="wyw-modal__close" aria-label="Close modal">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
            <path d="M1 1L15 15M15 1L1 15" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </button>
        <div class="wyw-modal__content">
          <div class="wyw-modal__body"></div>
        `;
      document.body.appendChild(modal);
      modal.querySelector('.wyw-modal__body').innerHTML = this.modalContent.innerHTML;
      setTimeout(() => {
        modal.open();
      }, 200);
    }
  }
}
customElements.define('wyw-modal-opener', WywModalOpener);


class RecentlyViewedProducts extends HTMLElement {
  static version = '1.0.4';

  constructor() {
    super();
    this.recentlyViewedProducts = [];
    this.localStorageKey = this.dataset.localStorageKey || '__recently_viewed_products__';
  }

  connectedCallback() {
    const storedVersion = localStorage.getItem('__recently_viewed_products_version__');
    if (storedVersion !== RecentlyViewedProducts.version) {
      localStorage.removeItem(this.localStorageKey);
      localStorage.setItem('__recently_viewed_products_version__', RecentlyViewedProducts.version);
    }
    this.loadRecentlyViewedProducts();
  }

  loadRecentlyViewedProducts() {
    const storedProducts = JSON.parse(localStorage.getItem(this.localStorageKey)) || [];
    this.recentlyViewedProducts = storedProducts;
    this.renderProducts();
  }

  unescapeHtml(text) {
    const temp = document.createElement('textarea');
    temp.innerHTML = text;
    return temp.value;
  }

  renderProducts() {
    const container = this.querySelector('.recently-viewed-products .swiper-wrapper');
    if (!container) return;

    container.innerHTML = '';

    const productTemplate = this.querySelector('template.recently-viewed--item-template');
    if (!productTemplate) return;

    if (this.recentlyViewedProducts.length === 0) {
      // hide the section if no products
      this.closest('.shopify-section').style.display = 'none';
      return
    }
    this.recentlyViewedProducts.forEach(product => {
        const productElement = productTemplate.content.cloneNode(true);
        const productLink = `/products/${product.handle}`;

        const hoverImage = productElement.querySelector('.more-in-collection__image--hover');
        if (hoverImage) {
          if (product.hoverImage) {
            hoverImage.src = product.hoverImage + '&width=400';
          } else {
            hoverImage.remove();
          }
        }

        const productFormDom = productElement.querySelector('product-form')
        if (productFormDom) {
          if (product.variantId && product.id && productFormDom.querySelector('input[name="id"]') && productFormDom.querySelector('input[name="product-id"]')) {
            productFormDom.querySelector('input[name="id"]').value = product.variantId;
            productFormDom.querySelector('input[name="product-id"]').value = product.id;
          } else {
            productFormDom.remove();
          }
        }

        const quickViewDom = productElement.querySelector('quick-view');
        if (quickViewDom) {
          quickViewDom.setAttribute('data-product-url', productLink);
        }

        const currentStoreCode = getCookie('mor_store_code');
        const priceDom = productElement.querySelector('.more-in-collection__price')
        if (priceDom) {
          if (currentStoreCode && product.storePrice) {
            const priceInfo = product.storePrice[currentStoreCode]
            const seePriceInCartMetafield = product.seePriceInCartMetafield;
            if (seePriceInCartMetafield === 'Y' || seePriceInCartMetafield === 'y') {
              priceDom.innerHTML = `<span data-store-price-value data-fixed-see-price-in-cart>See Price in Cart</span>`;
            } else if (priceInfo) {
              const { webPrice, regionPrice, onSale } = priceInfo;
              let priceToDisplay = ''
              const _webPrice = parseFloat(webPrice);
              const _regionPrice = parseFloat(regionPrice);
              if (onSale && _webPrice < _regionPrice) {
                  priceToDisplay = `<span data-store-price-value="">${formatPrice(webPrice)} </span><span data-store-original-price-value="">${formatPrice(regionPrice)}</span>`;
              } else if (onSale && _webPrice >= _regionPrice) {
                  priceToDisplay = `<span data-store-price-value="">${formatPrice(webPrice)}</span>`;
              } else {
                  priceToDisplay = `<span data-store-price-value="">${formatPrice(webPrice)}</span>`;
              }

              priceDom.innerHTML = priceToDisplay
            } else {
              priceDom.remove()
            }
          } else {
            priceDom.remove()
          }
        }

        const quickLookDom = productElement.querySelector('.more-in-collection__quicklook')
        if (quickLookDom) {
          productElement.querySelector('.more-in-collection__quicklook').href = productLink;
        }

        productElement.querySelector('product-collect').setAttribute('product-handle', product.handle);
        productElement.querySelector('.more-in-collection__title-link').innerHTML = product.title;
        productElement.querySelector('.more-in-collection__image-wrapper img').src = product.image + '&width=400';
        productElement.querySelector('product-collect').setAttribute('product-id', product.id);
        productElement.querySelector('.more-in-collection__title-link').href = productLink;
        productElement.querySelector('.more-in-collection__link').href = productLink;

        if (product.badgeTopDom) {
          try {
            let badgeTopContainer = productElement.querySelector('.more-in-collection__badges');
            const badges = this.unescapeHtml(product.badgeTopDom);
            if (!badgeTopContainer) {
              badgeTopContainer = document.createElement('div');
              badgeTopContainer.className = 'more-in-collection__badges';
              const badgeTopContainerWrapper = productElement.querySelector('.more-in-collection__card');
              badgeTopContainerWrapper.appendChild(badgeTopContainer);
            }
            badgeTopContainer.innerHTML = badges;
          } catch (e) {
            const badgeTopContainer = productElement.querySelector('.more-in-collection__badges');
            if (badgeTopContainer) badgeTopContainer.remove();
            console.error('Error parsing badgeTopDom:', e);
          }
        } else {
          const badgeTopContainer = productElement.querySelector('.more-in-collection__badges');
          if (badgeTopContainer) badgeTopContainer.remove();
        }
        container.appendChild(productElement);
    });
  }
}

customElements.define('recently-viewed-products', RecentlyViewedProducts);

class StorePrice extends HTMLElement {
  constructor() {
    super();
    this.defaultProductPrice = ''
    this.storesPrice = {};
  }

  connectedCallback() {
    const storesPriceDom = this.querySelector('script[data-store-price]');
    this.defaultProductPrice = this.dataset.defaultPrice || ''
    const whiteGloveScript = this.querySelector('script[type="application/json"][data-white-glove-tiers]');
    this.whiteGloveTiers = null;
    if (!storesPriceDom) return

    if (whiteGloveScript) {
      const whiteGloveTiersString = whiteGloveScript.textContent.trim();
      if (whiteGloveTiersString) {
         try {
          this.whiteGloveTiers = JSON.parse(whiteGloveTiersString);
        } catch (e) {
          console.error('Error parsing white glove tiers:', e);
        }
      }
    }
    const storesPriceString = storesPriceDom.textContent;
    try {
      this.storesPrice = JSON.parse(storesPriceString);
      
      this.getCurrentStoreCode()
      // console.log('this.currentStoreCode', this.currentStoreCode)
      this.renderPrice();
    } catch (e) {
      this.storesPrice = {};
    }
    this.bindCustomAfterpayEvent()
  }

  bindCustomAfterpayEvent() {
    const customAfterpayDom = this.querySelector('.custom-after-pay')
    if (customAfterpayDom) {
      customAfterpayDom.addEventListener('click', () => {
        const afterpayModalDom = document.querySelector('custom-afterpay-modal')
        if (afterpayModalDom) afterpayModalDom.open()
      })
    }
  }

  getFinalAndComparedPrice (currentStorePrice, withoutFormat) {
    const res = {
      finalPrice: withoutFormat ? this.defaultProductPrice : formatPrice(this.defaultProductPrice),
      comparedPrice: ''
    };

    if (currentStorePrice) {
      if (currentStorePrice.onSale === 'Y') {
        res.finalPrice = withoutFormat ? currentStorePrice.webPrice : formatPrice(currentStorePrice.webPrice);
        res.comparedPrice = withoutFormat ? currentStorePrice.regionPrice : formatPrice(currentStorePrice.regionPrice);
      } else {
        res.finalPrice = withoutFormat ? currentStorePrice.regionPrice : formatPrice(currentStorePrice.regionPrice);
      }
    }

    return res;
  }

  _renderWhiteGlovePriceOnPDPShippingMethods(price) {
    const whiteGloveHeadingDom = document.querySelector('#MainContent > section > product-info pdp-shipping-methods .white-glove-delivery-text')
    if(!whiteGloveHeadingDom) return
    const seePriceInCartText = whiteGloveHeadingDom.getAttribute('data-see-price-in-cart');
    const feeText = whiteGloveHeadingDom.getAttribute('data-fee');
    const freeText = whiteGloveHeadingDom.getAttribute('data-free');
    if (price === 'See price in cart') {
        if (whiteGloveHeadingDom && seePriceInCartText) {
          whiteGloveHeadingDom.textContent = 'White Glove Delivery';
        }
      return
    }
    if (!this.whiteGloveTiers || this.whiteGloveTiers.length === 0) return;
    const whiteGloveRenderDom = document.querySelector('#MainContent > section > product-info pdp-shipping-methods [data-white-glove-price]')
    if (!whiteGloveRenderDom) return;

    let servicePrice = ''

    for (const tier of this.whiteGloveTiers) {
      if (tier.min <= price && tier.max >= price) {
        servicePrice = tier.price;
        break;
      }
    }

    if (servicePrice === 0) {
      whiteGloveHeadingDom.textContent = freeText;
    } else {
      whiteGloveHeadingDom.textContent = feeText;
    }

    whiteGloveRenderDom.textContent = formatPrice(servicePrice)
  }

  renderPrice() {
    const priceDom = this.querySelector('[data-store-price-value]');
    const comparePriceDom = this.querySelector('[data-store-original-price-value]');
    let afterPayDom = this.querySelector('square-placement');
    const customAfterpayDom = this.querySelector('.custom-after-pay')

    const productInfo = this.closest('product-info');
    if (productInfo) {
      afterPayDom = productInfo.querySelector('square-placement');
    }
    const currentStorePrice = this.storesPrice[this.currentStoreCode];
    const mapPrice = currentStorePrice?.mapPrice;
    const webPrice = currentStorePrice?.webPrice;
    const regionPrice = currentStorePrice?.regionPrice;
    let finalPrice = regionPrice;
    let comparedPrice = ''
    let withoutFormatFinalPrice = regionPrice;

    if (mapPrice && mapPrice > Number(webPrice)) {
      finalPrice = 'See price in cart'

      if(this.closest('.wyw-product-info_price')) {
        this._renderWhiteGlovePriceOnPDPShippingMethods(finalPrice)
      }
    } else {
      const res = this.getFinalAndComparedPrice(currentStorePrice)
      const withoutFormatRes = this.getFinalAndComparedPrice(currentStorePrice, true)
      
      finalPrice = res.finalPrice
      comparedPrice = res.comparedPrice

      withoutFormatFinalPrice = withoutFormatRes.finalPrice
      // only render white glove price at main product info section on PDP
      if(this.closest('.wyw-product-info_price')) {
        this._renderWhiteGlovePriceOnPDPShippingMethods(withoutFormatFinalPrice)
      }
    }

    priceDom ? priceDom.textContent = finalPrice : null;
    comparePriceDom ? comparePriceDom.textContent = comparedPrice : null;
    if (afterPayDom && finalPrice !== 'See price in cart') {
      afterPayDom.setAttribute('data-amount', finalPrice.replaceAll(',', '').replace(/[^\d.]/g, ''));
    }
    if (customAfterpayDom) {
      if (finalPrice === 'See price in cart') {
        customAfterpayDom.style.display = 'none';
      } else {
        const afterpayAmountString = finalPrice.replaceAll(',', '').replace(/[^\d.]/g, '');
        const afterpayAmount = Math.floor(Number(afterpayAmountString) / 22.33 * 100) / 100;
        customAfterpayDom.querySelector('.price-value').textContent = afterpayAmount;
      }
    }
  }

  getCurrentStoreCode() {
    const storeCode = this.getCookie('mor_store_code') || (typeof getCookie === 'function' ? getCookie('mor_store_code') : null) || (typeof storeCodeFromUrl !== 'undefined' ? storeCodeFromUrl : '');

    if (!storeCode) return null;
    this.currentStoreCode = storeCode;
  }

  getCookie(name) {
    const nameEQ = name + "=";
    const ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) === ' ') c = c.substring(1, c.length);
      if (c.indexOf(nameEQ) === 0) return decodeURIComponent(c.substring(nameEQ.length, c.length));
    }
    return null;
  }
}
customElements.define('store-price', StorePrice);

class StorePricePDP extends StorePrice {
  constructor() {
    super();
    this.bindSynchronyLearnMoreClick()
    this.planTemplate = document.querySelector('template[data-synchrony-plan-item-template]');
  }

  bindSynchronyLearnMoreClick() {
    const synchronyLearnMoreDom = this.querySelector('.synchrony-learn-more');
    this.synchronyModal = document.querySelector('#PopupModal-pdpSynchrony');
    this.planTemplate = this.synchronyModal.querySelector('template[data-synchrony-plan-item-template]');
    this.availablePlanContainer = this.synchronyModal.querySelector('[data-plan-list-available-container]');
    this.unavailablePlanContainer = this.synchronyModal.querySelector('[data-plan-list-unavailable-container]');

    if (synchronyLearnMoreDom) {
      synchronyLearnMoreDom.addEventListener('click', () => {
        if (this.synchronyModal && typeof this.synchronyModal.show === 'function') {
          this.synchronyModal.show();
          this._updateSyncHronyPopup();
        }
      })
    }

    // .line-two__right click to scroll
    document.addEventListener('click', (e) => {
      if (e.target.closest('.line-two__right') && this.synchronyModal) {
        const scrollTarget = e.target.closest('.popup-modal__body--main').querySelector(`.plan-description__item[data-scroll-month="${e.target.closest('.line-two__right').dataset.scrollMonth}"]`);

        if (scrollTarget) {
          scrollTarget.scrollIntoView({ behavior: 'smooth' });
        }
      }
    })
  }

  _updateSyncHronyPopup() {
    const amountInput = this.synchronyModal.querySelector('input[name="synchronyAmount"]');
    if (!amountInput) return;
    amountInput.addEventListener('input', (e) => {
      // number only
      let _number = e.target.value.replace(/[^0-9.]/g, '');
      e.target.value = _number;
      this.amountInputValue = _number;

      console.log('synchrony amount input', e.target.value)
      this._updateSynchronyPlan()
    })
    amountInput.value = this.withoutFormatRes ? this.withoutFormatRes.finalPrice : '';
    // trigger input event to update the plan list
    const inputEvent = new Event('input', { bubbles: true });
    amountInput.dispatchEvent(inputEvent);
  }

  _getMonthByPrice() {
    const _price = this.amountInputValue;
    if (!_price) return [];

    let _result = []

    if (_price < 300) {
      _result = [6, 60]
    } else if (_price >= 300 && _price <= 999.98) {
      _result = [6, 60]
    } else if (_price >= 999.99 && _price <= 1999.99) {
      _result = [6, 12, 60]
    } else if (_price >= 2000) {
      // _result = [6, 12, 18, 60]
      _result = [6, 12, 60]
    }

    return _result;
  }

  _updateInStoreOnlyPlan(price) {
    const inStoreOnlyPlanDom = this.synchronyModal.querySelector('.plan-description__item--in-store-only');
    
    if (this.dataset.isMattress === 'true') {
      if (price >= 1999) {
        let months = 72;
        let monthlyPayment = new Big(price).div(months).round(0, Big.roundUp).toString();
        inStoreOnlyPlanDom.style.display = 'block';
        inStoreOnlyPlanDom.querySelector('[data-in-store-only-price]').textContent = formatPrice(monthlyPayment, 0);
        inStoreOnlyPlanDom.querySelector('[data-in-store-only-months]').textContent = months;
      } else {
        inStoreOnlyPlanDom.style.display = 'none';
      }
    } else {
      if (price < 3000) {
        inStoreOnlyPlanDom.style.display = 'none';
      } else {
        let months = 0;
        let monthlyPayment = 0;
        if (price >= 3000 && price <= 3999.99) {
          months = 31
        } else if (price >= 4000 && price <= 4999.99) {
          months = 41
        } else if (price >= 5000 && price <= 5999.99) {
          months = 51
        } else {
          months = 61
        }
        monthlyPayment = new Big(price).div(months).round(0, Big.roundUp).toString();
        inStoreOnlyPlanDom.style.display = 'block';
        inStoreOnlyPlanDom.querySelector('[data-in-store-only-price]').textContent = formatPrice(monthlyPayment, 0);
        inStoreOnlyPlanDom.querySelector('[data-in-store-only-months]').textContent = months;
      }
    }
    
  }

  _updateSynchronyPlan() {
    if (!this.planTemplate) return;
    const planListConfig = this.synchronyModal.querySelector('script[type="application/json"][data-plan-list-config]');

    if (!planListConfig) return;
    try {
      const planListConfigJson = planListConfig.textContent.trim();
      this.planListConfig = JSON.parse(planListConfigJson);
      const availableMonths = this._getMonthByPrice();
      const availablePlans = [];
      const unavailablePlans = [];
      const _price = this.amountInputValue;
      const _priceBigNumber = new Big(_price || 0);

      this._updateInStoreOnlyPlan(_price);

      this.availablePlanContainer.innerHTML = '';
      this.unavailablePlanContainer.innerHTML = '';

      this.planListConfig.forEach(plan => {
        const copyPlanItem = this.planTemplate.content.cloneNode(true);
        if (availableMonths.includes(plan.months)) {
          plan.total_payments = _price;
          if (plan.months === 60) {
            plan.monthly_payment = _priceBigNumber.div(47.07627).round(0, Big.roundUp).toString();
            plan.total_payments = _priceBigNumber.div(47.07627).mul(plan.months).round(0, Big.roundUp).toString();
          } else {
            plan.monthly_payment = _priceBigNumber.div(plan.months).round(0, Big.roundUp).toString();
          }
          availablePlans.push(plan);
          copyPlanItem.querySelector('[data-plan-months]').textContent = plan.months;
          copyPlanItem.querySelector('[data-plan-monthly-payment]').textContent = formatPrice(plan.monthly_payment, 0);
          copyPlanItem.querySelector('[data-plan-total-payments]').textContent = formatPrice(plan.total_payments, 0);
          copyPlanItem.querySelector('[data-plan-tips]').innerHTML = plan.tips
          copyPlanItem.querySelector('.line-two__right').setAttribute('data-scroll-month', plan.months);
          this.availablePlanContainer.appendChild(copyPlanItem);
        } else {
          plan.total_payments = 0
          plan.monthly_payment = 0
          copyPlanItem.querySelector('[data-plan-months]').textContent = plan.months;
          copyPlanItem.querySelector('[data-plan-monthly-payment]').textContent = '-';
          copyPlanItem.querySelector('[data-plan-total-payments]').textContent = '-';
          copyPlanItem.querySelector('[data-plan-tips]').innerHTML = plan.tips
          this.unavailablePlanContainer.appendChild(copyPlanItem);
          unavailablePlans.push(plan);
        }
      })
      if (unavailablePlans.length === 0) {
        this.synchronyModal.querySelector('.plan-list__unavailable-header').style.display = 'none';
      } else {
        this.synchronyModal.querySelector('.plan-list__unavailable-header').style.display = 'block';
      }
    } catch (e) {
      console.error('Error parsing plan list config:', e);
      return;
    }
  }

  updateSynchronyPrice(withoutFormatFinalPrice) {
    if (!withoutFormatFinalPrice) return;
    let _withoutFormatFinalPrice = withoutFormatFinalPrice
    if (typeof withoutFormatFinalPrice === 'string') {
      _withoutFormatFinalPrice = _withoutFormatFinalPrice.replaceAll(',', '')
    }
    try {
      const withoutFormatFinalPriceBigNumber = new Big(_withoutFormatFinalPrice);
      const _price = withoutFormatFinalPriceBigNumber.div(47.07627).round(0, Big.roundUp);
      this.classList.add('has-synchrony-price');
      const productInfoWrapper = this.closest('.product__info-wrapper');
      if (productInfoWrapper) productInfoWrapper.classList.add('product__info-wrapper--has-synchrony-price');
      const synchronyPriceEl = this.querySelector('[data-store-synchrony-price]');
      if (synchronyPriceEl) synchronyPriceEl.textContent = formatPrice(_price, 0);
    } catch (e) {
      console.error('Error updating synchrony price:', e);
    }
  }

  renderPrice() {
    const priceDom = this.querySelector('[data-store-price-value]');
    const comparePriceDom = this.querySelector('[data-store-original-price-value]');
    let afterPayDom = this.querySelector('square-placement');
    const customAfterpayDom = this.querySelector('.custom-after-pay')

    const productInfo = this.closest('product-info');
    if (productInfo) {
      afterPayDom = productInfo.querySelector('square-placement');
    }

    const seePriceInCartMetafield = this.dataset.seePriceInCart;
    if (seePriceInCartMetafield === 'true') {
      const finalPrice = 'See price in cart';
      if (priceDom) {
        priceDom.textContent = finalPrice;
        priceDom.setAttribute('data-fixed-see-price-in-cart', '');
      }
      if (comparePriceDom) comparePriceDom.textContent = '';
      if (customAfterpayDom) customAfterpayDom.style.display = 'none';
      if(this.closest('.wyw-product-info_price')) {
        this._renderWhiteGlovePriceOnPDPShippingMethods(finalPrice)
      }
      return;
    }

    const currentStorePrice = this.storesPrice[this.currentStoreCode];
    const webPrice = currentStorePrice?.webPrice;
    const regionPrice = currentStorePrice?.regionPrice;
    let finalPrice = regionPrice;
    let comparedPrice = ''
    let withoutFormatFinalPrice = regionPrice;

    {
      const res = this.getFinalAndComparedPrice(currentStorePrice)
      const withoutFormatRes = this.getFinalAndComparedPrice(currentStorePrice, true)
      this.withoutFormatRes = withoutFormatRes;
      
      finalPrice = res.finalPrice
      comparedPrice = res.comparedPrice

      withoutFormatFinalPrice = withoutFormatRes.finalPrice
      // only render white glove price at main product info section on PDP
      if(this.closest('.wyw-product-info_price')) {
        try {
          this._renderWhiteGlovePriceOnPDPShippingMethods(withoutFormatFinalPrice)
        } catch(e) {
          console.error('store pdp error', e)
        }
      }

      if (this.querySelector('[data-store-synchrony-price]')) {
        this.updateSynchronyPrice(withoutFormatFinalPrice)
      }
    }

    priceDom ? priceDom.textContent = finalPrice : null;
    comparePriceDom ? comparePriceDom.textContent = comparedPrice : null;
    if (afterPayDom && finalPrice !== 'See price in cart') {
      try {
        afterPayDom.setAttribute('data-amount', finalPrice.replaceAll(',', '').replace(/[^\d.]/g, ''));
      } catch(e) {}
    }
    if (customAfterpayDom) {
      if (finalPrice === 'See price in cart') {
        customAfterpayDom.style.display = 'none';
      } else {
        try {
          const afterpayAmountString = finalPrice.replaceAll(',', '').replace(/[^\d.]/g, '');
          const afterpayAmount = Math.floor(Number(afterpayAmountString) / 22.33 * 100) / 100;
          const priceValueEl = customAfterpayDom.querySelector('.price-value');
          if (priceValueEl) priceValueEl.textContent = afterpayAmount;
        } catch(e) {}
      }
    }
  }
}
customElements.define('store-price-pdp', StorePricePDP);

document.addEventListener('click', function (e) {
  const afterpayDom = e.target.closest('.more-in-collection__price-range .custom-after-pay');
  if (!afterpayDom) return;
  const afterpayModalDom = document.querySelector('custom-afterpay-modal');
  if (afterpayModalDom) afterpayModalDom.open();
});

class CustomAfterPayModal extends HTMLElement {
    constructor() {
      super();
      this.closeBtn = this.querySelector('.afterpay-close-button');
      this.overlaybg = this.querySelector('.modal-overlay');
    }

    open() {
        this.classList.add('active');
      }

      close() {
        this.classList.remove('active');
  }

  connectedCallback() {
      if (this.closeBtn) {
        this.closeBtn.addEventListener('click', this.close.bind(this));
      }
      
      if (this.overlaybg) {
        this.overlaybg.addEventListener('click', this.close.bind(this));
      }
    }
  }

customElements.define('custom-afterpay-modal', CustomAfterPayModal);



class CardColorSwatches extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const _this = this;
    const color_swatches = this.querySelectorAll(".color-option-swatch");
    const default_swatch = this.querySelector(".color-option-swatch.default");
    const productCardSelector = this.getAttribute('data-product-card-selector') || '.more-in-collection__card';
    const productImageSelector = this.getAttribute('data-product-image-selector') || '.more-in-collection__link img';

    color_swatches.forEach((swatch) => {
        swatch.addEventListener("mouseenter", () => {
              const imageUrl = swatch.getAttribute("data-image");
              const productCard = swatch.closest(productCardSelector);
              if (!productCard) return;

              const img = productCard.querySelector(productImageSelector);
              if (!img) return;

              const default_src = img.getAttribute("src");
              img.setAttribute("data-default-src", default_src);
              img.setAttribute("src", imageUrl);
              
              const all_swatches = _this.querySelectorAll(".color-option-swatch");
              all_swatches.forEach((swatch) => {
                swatch.classList.remove("active");
              });
              if (!swatch.classList.contains("active")) {
                swatch.classList.add("active");
              }
        });

        swatch.addEventListener("mouseleave", () => {
            const productCard = swatch.closest(productCardSelector);
            if (!productCard) return;

            const img = productCard.querySelector(productImageSelector);
            if (!img) return;

            const default_src = img.getAttribute("data-default-src");
            img.setAttribute("src", default_src);
            img.removeAttribute("data-default-src");
            
            const all_swatches = _this.querySelectorAll(".color-option-swatch");
            all_swatches.forEach((swatch) => {
                swatch.classList.remove("active");
            });
            if (default_swatch) default_swatch.classList.add("active");
        })
    });
  }
}

customElements.define('card-color-swatches', CardColorSwatches);

customElements.define('set-my-store', class extends HTMLElement {
    constructor() {
        super();
    }

    async updateCartAttribute(storeCode) {
      try {
        const response = await fetch('/cart/update.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            attributes: {
              'mor_store_code': storeCode
            }
          })
        });

        if (!response.ok) {
          throw new Error('Failed to update cart');
        }

        const cart = await response.json();
        // console.log('Cart updated with:', cart.attributes);
      } catch (error) {
        console.error('Error updating cart:', error);
      }
    }

    loading(isLoading) {
        if (isLoading) {
            this.querySelector('.loading__spinner').classList.remove('hidden');
        } else {
            this.querySelector('.loading__spinner').classList.add('hidden');
        }
    }

    connectedCallback() {
        this.addEventListener('click', async () => {
            const zipCode = this.getAttribute('data-zipcode');
            const storeName = this.getAttribute('data-store-name') || '';
            const storeCode = this.getAttribute('data-store-code') || '';
            const warehouseCode = this.getAttribute('data-warehouse-code') || '';

            // setCookie('mor_zipcode', zipCode);
            setCookie('mor_store_code', storeCode);
            setCookie('mor_warehouse_code', warehouseCode);
            setCookie('mor_store_name', storeName);
            try {
              this.loading(true);
              await this.updateCartAttribute(storeCode);
              if (window.location.search.includes('filter.v.m.custom.store_on_display')) {
                const url = new URL(window.location);
                url.searchParams.set('filter.v.m.custom.store_on_display', storeCode);
                window.history.replaceState({}, '', url);
              }
              window.location.reload();
              setTimeout(() => {
                this.loading(false);
              }, 2000);
            } catch (error) {
              console.error('Error updating cart attributes:', error);
              this.loading(false);
            }
        });
    }
})
